import Cleave from 'cleave.js/react';
import creditCardType from 'credit-card-type';
import React, { Component } from 'react';
import Avatar from 'react-avatar';
import { BrowserView, MobileView, isAndroid, isIOS } from 'react-device-detect';
import { MonthPicker, YearPicker } from 'react-dropdown-date';
import ReactFileReader from 'react-file-reader';
import { BrowserRouter as Router } from "react-router-dom";
import Cookies from 'universal-cookie';
import HideBtn from "../../assets/components/button/HideBtn";
import SideBtn from "../../assets/components/button/SideBtn";
import WaitLoad from "../../assets/components/loading/WaitLoad";
import AlertPnl from "../../assets/components/panel/AlertPnl";
import AllMovMinMainPnl from "../../assets/components/panel/AllMovMinMainPnl";
import AllMovPnl from "../../assets/components/panel/AllMovPnl";
import MainPnl from "../../assets/components/panel/MainPnl";
import MinMainPnl from "../../assets/components/panel/MinMainPnl";
import MovMinMainPnl from "../../assets/components/panel/MovMinMainPnl";
import MovSubPnl from "../../assets/components/panel/MovSubPnl";
import '../../CommonStyles/CSS.css'; //ssnt
import { Config } from "../../Config";
import mastercard from '../../images/public/bank/Mastercard.png';
import masterviza from '../../images/public/bank/masterviza.png';
import qmark from '../../images/public/bank/qmark.png';
import visacard from '../../images/public/bank/Visa.png';
import logo from '../../images/public/login/logo.png';
import close from '../../images/public/registeration/clos.png';
import application from '../../images/public/userarea/application.png';
import assisfaq from '../../images/public/userarea/assisfaq.png';
import assismail from '../../images/public/userarea/assismail.png';
import assistel from '../../images/public/userarea/assistel.png';
import btnapplestore from '../../images/public/userarea/btnapplestore.png';
import btngoogleplay from '../../images/public/userarea/btngoogleplay.png';
import crdcredit from "../../images/public/userarea/crdcredit.png";
import logout from "../../images/public/userarea/logout.png";
import profilee from '../../images/public/userarea/profilee.png';
import reserveToResortImg from '../../images/public/userarea/reserveToResortImg.png';
import tab1s from "../../images/public/userarea/tab1s.png";
import tab1u from "../../images/public/userarea/tab1u.png";
import tab2s from "../../images/public/userarea/tab2s.png";
import tab2u from "../../images/public/userarea/tab2u.png";
import tab3s from "../../images/public/userarea/tab3s.png";
import tab3u from "../../images/public/userarea/tab3u.png";
import tab4s from "../../images/public/userarea/tab4s.png";
import tab4u from "../../images/public/userarea/tab4u.png";
import tab5s from "../../images/public/userarea/tab5s.png";
import tab5u from "../../images/public/userarea/tab5u.png";
import ticketIcon from "../../images/public/userarea/ticketIcon.png";
import {
  changeEmail,
  changeUserPasswordFetch,
  checkUser,
  confirmEmail,
  createCCInsertionUrl,
  deleteCart,
  deleteCreditCard,
  deleteUserFetch,
  disableCardFetch,
  getCardsFetch,
  getCreditCardInfo,
  getPartnerInfo,
  getServicePrice,
  getSkiers,
  getUserResponses,
  isLogged,
  modifyEmail,
  renewService,
  searchForNewContracts,
  sendCodeByEmail,
  updateContracts,
  updateProfilePictureFetch,
  updateStatusWalletPartner,
  // updateUserFetch,
  updateUser,
  userFetch,
  userLogoutFetch,
  validateCoupon
} from '../../libs/fetch';
import tr from '../../libs/tr';
import './Userarea.css';
// import { workflowCreat, workflowState, updateWorkflow } from "../../libs/workflow";
import { Alert } from 'react-bootstrap';
import GestPayHandler from '../../assets/components/bank/GestPayHandler';
import MPWorkFlow from "../../libs/workflow";
// const stageName = "Home";

let user;
let cookies = new Cookies;
const MAX_SKIERS = 5; // num max of skiers per user

class Userarea extends Component {



  constructor(props) {
    super(props);

    document.getElementById("mypass-ski-title").innerHTML = "Account - MyPass Ski Area Utente";
    document.body.classList.add('alt_bg');

    // console.log("rrrrrrrrrrrrrrrrrrrrrrr", typeof localStorage.getItem('user'), localStorage.getItem('user'));

    if ((localStorage.getItem('user')) == 'undefined' || !localStorage.getItem('user')) {
      this.logout();
      window.location.replace("/")
      // return window.location.reload();
    }
    if ((localStorage.getItem('user')) != 'undefined' && localStorage.getItem('user')) {
      this.user = JSON.parse(localStorage.getItem('user'));
    }

    this.state = {

      screenNum: 1, // default view Screen - 1st tab of side buttons (Profile screenNum is 0)
      panelType: 2, // default view Panel - 1 for maximized user panel and 2 for minimized user panel

      // payment method
      noMethod: true, // It is false when the user added a payment method during registeration
      methodView: 1,  // view state if has a method - 1 for overview of added method and 2 for changing payment method
      nomethodView: 1, // view state if has no method - 1 for notice to add a method and 2 for adding a payment method
      showThirdPartyAlert: false,
      partners: [],// if user is a partner user her information including wallet and en/disabled is wrapped here
      // profile
      profileView: 1, // profile tab screens

      // skiers
      noSkier: true, // by default has no skier - No skier notice
      maxNumUser: false, // It should be true when we have 5 skier and the "Add new skier" button will hide

      // payment movement - switch movements views
      movFlag: true,
      allmovFlag: true,

      //password
      passErru: false,
      passFlagu: true,

      radio1p: true,
      radio2p: false,
      radio3p: true,
      radio4p: false,

      modal: false, // True when we have a popup
      alertBlock: false, // Card blocking popup
      alertDocument: false, // Documents upload needed popup
      alertCard: false, // Expired card popup
      alertPayment: false, // Incomplete payment popup
      alertModification: false, // Data modified popup
      alertElimination: false, // Delete account popup
      alertResendemail: false, // Resend email popup
      alertRenewservice: false, // Service renewal popup

      loading: false, // True when user should wait

      Active: false, // True when we have an added user without any alert ( !BLOCK && !Activate )
      Block: false, // True when the card is blocked
      Expired: false, // True when the card is expired
      // before render
      loadedData: false,

      // user
      user: {},

      // skiers
      skiers: [],
      activeSkier: {},

      // no card state
      noCard: false,

      // change password form state
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',

      // change mail error state
      emailErr: false,

      // change user info status
      Phonenumberform: "+39 3334423535",
      Fiscalcodeform: "JHNDOE65T45G567I",
      profilePic: null, // default state user pic upload value

      // placeholders data (to replace in i18n files)

      Cvvform: "***",
      Fullname: "John Doe",
      FullnameB: "Liam Doe",
      Fullnameform: "John Doe",
      Birthdayform: "16/05/1965",
      Passwordform: "**********",

      Emailform: "johndoe@gmail.com",
      Emailformnew: "johndoe@gmail.com",
      Emailnew: "nuovamail@gmail.com",
      Banknumber: "**** **** **** 5036",
      Banknumberform: "**** **** **** 5036",
      Bankexpiration: "06/19",
      Monthform: null,
      Yearform: null,

      //Bank part
      modal: false,
      alertWrong: false,
      isLoading: false,
      errmsg: null,
      errorFlg: false,
      purchaseCart: null, //the data inside strPurchaseCard is parsed and converted to object array as we want and then is stored in storage
      totalPrice: 0,
      cardHolder: "",
      cardNumber: "",
      cvv: "",
      expDate: "",
      yyyy: "",
      mm: "",
      paymentType: "change",//"insert"
      tokenized: true,
      ccInfoErr: true,
      errCvv: false,
      errCardHolderName: false,
      errCCNumber: false,
      ccType: '', //Visa, Mastercard, etc.
      doesCartExist: false,

      checkUser: false,
      emailCode: '',
      scadenza_contratto: '',
      userFeedbackForDeletion: false,

      gestpay: false,
      bankErrMsg: tr.t("Nosuccess"),
      voucher: '',
      failureMessage: '',
      successMessage: '',
      renewEnabled: true,
      renewVisible: false,
      discount: 0,
      validVoucher: false,
      isLoading: false,
      renewServicePrice: null,
      resultDetails: false,
    };

    this.change1 = this.change1.bind(this);
    this.change2 = this.change2.bind(this);
    this.change3 = this.change3.bind(this);
    this.change4 = this.change4.bind(this);
    this.change5 = this.change5.bind(this);
    this.change0 = this.change0.bind(this);
    this.changemovpnl = this.changemovpnl.bind(this);
    this.changeallmovpnl = this.changeallmovpnl.bind(this);
    this.changemax = this.changemax.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSavem = this.handleSavem.bind(this);
    this.handleCancelm = this.handleCancelm.bind(this);
    // this.handleSelectCardType = this.handleSelectCardType.bind(this);
    this.handleInsert = this.handleInsert.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSavedata = this.handleSavedata.bind(this);
    this.handleDeleteaccount = this.handleDeleteaccount.bind(this);
    this.handleForwarde = this.handleForwarde.bind(this);
    this.handleForwardp = this.handleForwardp.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCancelWrongEmail = this.handleCancelWrongEmail.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.mpcallback = this.mpcallback.bind(this);
    this.updateValuene = this.updateValuene.bind(this);
    this.handleCancelm = this.handleCancelm.bind(this);

    // change pwd handles
    this.handleChangeOldPassword = this.handleChangeOldPassword.bind(this);
    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
    this.handleChangeConfirmPassword = this.handleChangeConfirmPassword.bind(this);

    // change user handles
    this.uploadProfilePic = this.uploadProfilePic.bind(this);
    this.getUserProfilePic = this.getUserProfilePic.bind(this);

    //bank functions
    this.onCreditCardChange = this.onCreditCardChange.bind(this);
    this.onCVVchange = this.onCVVchange.bind(this);

    //alert from user movments in 
    this.onAlert = this.onAlert.bind(this);

    this.CCStartYear = new Date().getFullYear();
    this.CCEndYear = this.CCStartYear + 10;
  }


  checkForBankCallbackInURI() {
    console.log("[userarea] @checkForBankCallbackInURI #window.location: ", window.location.href);

    function findGetParameter(name) {
      let url = window.location.href;
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    }


    var bankResponse = findGetParameter("bankResponse");
    var data = findGetParameter("data");
    console.log("[userarea] @checkForBankCallbackInURI #bankResponse: ", bankResponse);
    console.log("[userarea] @checkForBankCallbackInURI #data: ", data);

    if (bankResponse) {
      // clear browser
      window.location.href = window.location.href.split("?")[0];
      console.log("[userarea] @checkForBankCallbackInURI #window.location.href.split(?)[0]: ", window.location.href.split("?")[0]);
      console.log("[userarea] @checkForBankCallbackInURI #decodeURIComponent(data): ");
      if (bankResponse.indexOf("_OK") > -1) {
        // bring back the CC insertion
        this.setState({ isLoading: false, screenNum: 3 })
      }
      if (bankResponse.indexOf('_KO') > -1) {
        this.setState({ isLoading: false });
        //ERROR in payment
        // go to cc part
        // and open the cc insertion screen
        this.setState({
          screenNum: 3,
          nomethodView: 2,
        });
      }
    }
  }


  componentDidMount() {
    this.checkForBankCallbackInURI();


    // this.wf = new MPWorkFlow();
    this.stgageName = MPWorkFlow.getInstance().getStageName("Home");

    //clear cart, purchasecart
    localStorage.setItem("cart", null);
    localStorage.setItem("purchaseCart", null);
    localStorage.setItem("limitedPurchase", null);
    localStorage.setItem("linkedUser", null);
    localStorage.setItem("backto", null);
    localStorage.setItem("totalPrice", null);
    localStorage.setItem("updateAndGoToHome", null);
    // localStorage.setItem("price_info", null);

    // localStorage.setItem("confirmedvoucher_code", null);

    // check logged user

    if (!isLogged()) {
      console.log('Sorry NOT LOGGED');
      return this.props.history.push('/');
    }

    let access_token = cookies.get('access_token');

    userFetch(this, { access_token: access_token }
    ).then((response) => {
      console.log(response);
      if (response) {
        user = response;
        this.setState({ user: user }, () => {
          this.getRenewServicePrice();
        });
        localStorage.setItem('user', JSON.stringify(response));
        const { email, data_nasc, tel_cell } = user;
        console.log('[userarea] @user01:', !!email, !!data_nasc, !!tel_cell);
        if (!email || !data_nasc || !tel_cell) {
          return this.props.history.push('/');
        }
        this.checkUser();


        // //get creditcard info of the user
        // this.getCreditCardInfo();

        // check user has skiers
        this.getCards();

        // set user mail in resend/modifyMail form
        this.setState({ Emailformnew: user.email });

        // set user profile editable fields form
        this.setState({
          Phonenumberform: user.tel_cell,
          Fiscalcodeform: user.fiscal_code
        })
        // loadedData
        this.setState({ loadedData: true });
      } else {
        this.logout()
      }
    });

  }

  handleEdit = (e) => {
    e.preventDefault()
    this.setState({ methodView: 2 });
  }

  handleSavem = (e) => {
    e.preventDefault()
    // this.setState({ methodView: 1 });
    this.onSubmitBankRequest("change");
  }

  handleCancelm = (e) => {
    e.preventDefault()
    this.setState({ methodView: 1 })
  }

  handleDelete = (e) => {
    e.preventDefault()
    this.setState({ modal: true, deleteCC: true })

    // this.deleteCreditCard();

  }

  // handleSelectCardType = (e) => {
  //     e.preventDefault()
  //     this.setState({ nomethodView: 0 });
  // }

  handleInsert = (e) => {
    e.preventDefault()
    this.openCreditCardForm();
  }

  openCreditCardForm = () => {
    let params = {
      bank: {
        shopLogin: Config.bank.shopLogin,
        portal: Config.bank.portal,
        test: Config.bank.test
      },
      userId: this.state.user.id_ut,
      paymentType: "Insert",
      amountCents: this.state.totalPrice * 100, //In case of edit or insertion, will be handled by bank
      checked: this.state.tokenized,
      configTest: Config.test,
      token: cookies.get('access_token'),
      EXPMM: this.state.mm.padStart(2, "0"),
      EXPYY: this.state.yyyy.substr(2, 2),
      CC: this.state.cardNumber,
      CVV2: this.state.cvv,
      BuyerName: this.state.cardHolder,
      lang: tr.userlng(),
    };
    createCCInsertionUrl(this, params.token, {
      paymentType: params.paymentType,
      amountCents: params.amountCents,
      test: params.bank.test,
      shopLogin: params.bank.shopLogin,
      // refund: refund //sure ?
    }).then((response) => {
      console.log("createCCInsertionUrl", response);
      if (response.status === 'success') {
        if (response.method === 'POST') {
          const postUrl = response.merchant_url;
          const postData = this.preparePostData(response.post_data);

          const iframe = document.createElement('iframe');

          iframe.style.width = '70%';
          iframe.style.height = '85%';
          iframe.style.position = 'fixed';
          iframe.style.top = '55%';
          iframe.style.left = '50%';
          iframe.style.transform = 'translate(-50%, -50%)';
          iframe.style.borderRadius = '20px';
          iframe.style.zIndex = '9999';
          iframe.style.border = 'none';

          document.body.appendChild(iframe);

          const form = document.createElement('form');
          form.method = 'POST';
          form.action = postUrl;
          form.target = iframe.name;

          const formData = new URLSearchParams(postData);

          formData.forEach((value, key) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
          });

          iframe.contentWindow.document.body.appendChild(form);

          window.addEventListener('message', (event) => {
            try {
              const data = JSON.parse(event.data);
              // console.log('Received message from iframe:', data);
              localStorage.setItem('nexiPaymentStatus', data.status);

              this.setState({ workFlowInProgress: true });
              if (data.status === 'OK') {
                iframe.remove();
                this.props.history.push('/');
                this.getCreditCardInfo();
              } else if (data.status === 'KO') {
                iframe.remove();
                this.props.history.push('/');
                this.getCreditCardInfo();
                this.setState({ alertWrongCCInsertion: true, modal: true, wrongCCInsertionError: data.description })
              }
              setTimeout(() => {
                this.setState({ workFlowInProgress: false })
              }, 2000);
            } catch (e) {
              console.error('Error parsing message from iframe:', e);
            }
          });

          this.setState({ workFlowInProgress: true });
          form.submit();
          setTimeout(() => {
            this.setState({ hidePay: true }, () => {
              this.setState({ iframe: iframe, showIframe: true, workFlowInProgress: false });
            });
          }, 5000);
        } else {
          this.setState({ nomethodView: 2 });
        }
      }
    });
  }

  handleSave = (e) => {
    e.preventDefault()
    // this.setState({ noMethod: false });
    this.onSubmitBankRequest("insert");
  }

  handleSavedata = (e) => {
    e.preventDefault()
    this.setState({ modal: true, alertModification: true })
  }

  handleDeleteaccount = (e) => {
    e.preventDefault()
    this.setState({ modal: true, alertElimination: true })
  }

  // handleResend = (e) => {
  //     e.preventDefault()
  //     this.setState({ modal: true, alertResendemail: true })
  // }

  handleForwarde = (e) => {
    e.preventDefault()
    this.setState({ profileView: 2 })
  }

  handleForwardp = (e) => {
    e.preventDefault()
    this.setState({ profileView: 3 })
  }

  handleCancel = (e) => {
    e.preventDefault()
    this.setState({ profileView: 1 })
  }

  handleCancelWrongEmail = (e) => {
    e.preventDefault()
    this.setState({ profileView: 4, isEmailValid: false });
  }

  handleConfirm = (e) => {
    e.preventDefault()
    this.changeUserPassword();
  }

  handleContinue = (e) => {
    e.preventDefault()
    this.changeUserEmail();
  }

  change1 = () => {
    console.log("scr1", this.state.screenNum)
    if (this.state.checkUser) return this.props.history.push('/');
    this.setState({ screenNum: 1 })
  }

  change2 = () => {
    console.log("scr2", this.state.screenNum)
    if (this.state.checkUser) return this.props.history.push('/');
    this.setState({ screenNum: 2 })
  }

  change3 = () => {
    console.log("scr3", this.state.screenNum)
    if (this.state.checkUser) return this.props.history.push('/');
    this.setState({ screenNum: 3 })
  }

  change4 = () => {//Privacy
    console.log("scr4", this.state.screenNum);
    if (this.state.checkUser) return this.props.history.push('/');
    this.setState({ screenNum: 4 });
    this.getUserResponses();
  }

  change5 = () => {
    console.log("scr5", this.state.screenNum)
    if (this.state.checkUser) return this.props.history.push('/');
    this.setState({ screenNum: 5 })
  }

  change0 = () => {
    console.log("scr0", this.state.screenNum)
    this.setState({ screenNum: 0 })
  }

  changemovpnl = (info) => {
    console.log("changemovpnl", info);
    this.setState({ movFlag: !this.state.movFlag, selectedSkier: info })
  }

  changeallmovpnl = () => {
    this.setState({ allmovFlag: !this.state.allmovFlag })
  }

  changemax = (e) => {
    console.log(e);
    this.setState({ panelType: 1 });
  }

  changeTo = function (e) {
    this.setState({ Fullnameform: e.target.value });
  }

  updateValue = function (e) {
    this.setState({ Fullnameform: e.target.value });
  }

  changeTon = function (e) {
    this.setState({ Banknumberform: e.target.value });
  }

  updateValuen = function (e) {
    this.setState({ Banknumberform: e.target.value });
  }

  changeToc = function (e) {
    this.setState({ Cvvform: e.target.value });
  }

  updateValuec = function (e) {
    this.setState({ Cvvform: e.target.value });
  }

  changeTopn = function (e) {
    this.setState({ Phonenumberform: e.target.value });
  }

  updateValuepn = function (e) {

    this.setState({ Phonenumberform: e.target.value.replace(/[^0-9]/, '') });
  }

  changeTone = function (e) {
    this.setState({ Emailformnew: e.target.value });
  }

  updateValuene = function (e) {
    this.setState({ Emailformnew: e.target.value });
  }


  validateEmail = () => {
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    var validEmail = regexp.test(this.state.Emailformnew);
    this.setState({ emailErr: !validEmail })
    return validEmail;
  }

  radio1p = () => {
    this.setState({ radio1p: true, radio2p: false })
  }

  radio2p = () => {
    this.setState({ radio1p: false, radio2p: true })
  }

  radio3p = () => {
    this.setState({ radio3p: true, radio4p: false })
  }

  radio4p = () => {
    this.setState({ radio3p: false, radio4p: true })
  }


  // change password handles 

  handleChangeOldPassword = (e) => {
    this.setState({ oldPassword: e.target.value });
  }

  handleChangeNewPassword = (e) => {
    this.setState({ newPassword: e.target.value });
  }

  handleChangeConfirmPassword = (e) => {
    this.setState({ newPasswordConfirm: e.target.value });
  }

  validatePassword = () => {

    // TODO regexp password validation

    this.setState({ passErru: !this.isPasswordTheSame() });
    return this.isPasswordTheSame()
  }

  //TODO  
  isPasswordTheSame = () => {
    return this.state.newPassword === this.state.newPasswordConfirm;
  }



  //Check if user is enabled, confirmed email, accepted privacy, etc..
  checkUser = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    checkUser(this, access_token, {
      email: this.state.user.email,
      portal: 'sci'
    })
      .then((response) => {
        this.setState({ isLoading: false });
        console.log("[Userarea] checkUser @response: ", response);


        switch (response.status) {
          case 'user_not_confirmed_email':
            if (response.redirect != "area_utente") {
              return this.props.history.push('/confirm');
            } else {
              this.setState({
                screenNum: 0,
                profileView: 4,
                checkUser: true,
              });
              this.resendEmailCall(true);
              break;
            }
          case 'privacy_not_done':
            localStorage.setItem('backto', 'userarea');
            return this.props.history.push('/terms');
            break;
          case "fail":
            return this.props.history.push('/');
          default:
            //check if there is no new policy for accept

            this.searchForNewContracts();
            break;
        }


      });
  }

  //check if there is no new policy for accept
  searchForNewContracts = () => {
    this.setState({ isLoading: true });
    searchForNewContracts(this, {
      portal: 'sci'
    })
      .then((response) => {
        this.setState({ isLoading: false });
        console.log("[Userarea] searchForNewContracts @response: ", response);

        //TODO: remove next lin and uncomment the the code bellow for production
        // this.getCreditCardInfo();
        if (response.status == 'success') {
          //Policies are fine! Getting creditcard info of the user
          this.getCreditCardInfo();
        } else {
          localStorage.setItem('backto', 'userarea');
          return this.props.history.push('/terms');
        }
      });
  }

  //Add new Skier
  handleAddNewSkier = () => {

    // checking the latest cart. if empty, it will create a new cart. 
    // else, it'll ask user if want to continue or delete the cart
    this._creat(0, 'skicart');

  }

  _creat(force, wf) {
    try {
      let _params = { force: force, workflow: wf };
      // 
      if (wf === "skiaddcard") {
        console.log("[userarea] @_creat #this.state.activeSkier[0].id: ", this.state.activeSkier[0].id);
        _params.linkeduser = this.state.activeSkier[0].id;
      }
      MPWorkFlow.getInstance().workflowCreat(this, _params).then(response => {
        console.log("[userarea] @workflowCreat #response: ", response);
        if (!response) return;
        if (response.status === "success") {
          // new cart can be generated
          // storing cart in storage
          MPWorkFlow.getInstance().updateWorkflow(this, response.data);
          // FirebaseLogger.getInstance().regEvent("Have", {}, "Navigate");
          localStorage.setItem("price_info", null);
          return this.props.history.push('/WelcomeScreen'); //cart is empty user needs to restart the purchase
        } else if (response.status === "fail") {
          if (response.error_code == 2) {
            // a cart already exists
            this.setState({ doesCartExist: true });
          } else {
            this.setState({
              helpShow: true,
              helpMessage: response.message
            })
          }
        }
      });
    } catch (error) {
      console.log("[userarea] @_creat #error: ", error);
    }
  }

  async getLastState() {
    let resp = await MPWorkFlow.getInstance().workflowState(this);
    console.log('[Userarea] @getLastState #resp', resp);
    if (!resp) return;
    if (resp.status === "success") {
      // updating localStorage
      MPWorkFlow.getInstance().updateWorkflow(this, resp.data);
      // updating current screen
      let nextScreen = MPWorkFlow.getInstance().getRouteName(resp.data.currentstate);
      // FirebaseLogger.getInstance().regEvent(resp.data.currentstate, {}, "Navigate");
      return this.props.history.push(nextScreen);
    } else if (resp.status === "fail") {
      this.setState({ errorFlg: true, errmsg: resp.message, isLoading: false });
    }
  }

  //empty the cart
  deleteCart = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    deleteCart(this, access_token, {})
      .then((response) => {
        this.setState({ isLoading: false });
        console.log("[Userarea] deleteCart @response: ", response);
        if (response.status == "success") {
          localStorage.setItem("purchaseCart", null);
          localStorage.setItem("confirmedvoucher_code", null);
          return this.props.history.push('/welcome'); //cart is empty user needs to restart the purchase
        } else {
          this.setState({
            errorFlg: true,
            errmsg: response.message
          });
        }
      });
  }



  getUserResponses = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    let params = {};
    getUserResponses(this, access_token, params).then((response) => {
      this.setState({ isLoading: false });
      console.log("[Userarea] getUserResponses @response: ", response);
      if (response) {
        this.setState({ radio1pbackup: (response[0].accepted == 1), radio2pbackup: (response[0].accepted != 1) })
        this.setState({ radio3pbackup: (response[1].accepted == 1), radio4pbackup: (response[1].accepted != 1) })

        this.setState({ privacyId0: response[0].id_contract, privacyId1: response[1].id_contract });
        this.setState({ radio1p: (response[0].accepted == 1), radio2p: (response[0].accepted != 1) });
        this.setState({ radio3p: (response[1].accepted == 1), radio4p: (response[1].accepted != 1) });
      }
    });
  }

  updateContracts = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    const { privacyId0, privacyId1, radio1p, radio3p } = this.state;
    let params = {
      portal: 'sci',
      consents: (privacyId0.toString() + ':' + (radio1p ? '1' : '0')) + ',' + (privacyId1.toString() + ':' + (radio3p ? '1' : '0')),
      platform: "web",
    };
    updateContracts(this, access_token, params)
      .then((response) => {
        this.setState({ isLoading: false });
        console.log("[Userarea] updateContracts @response: ", response);
        this.handleAlert(response.message);
        this.getUserResponses();
      });
  }

  // alert response callback
  // set UI state switch close / actions -> {.. list}
  alertResponse(info) {
    this.forceUpdate(() => {
      console.log("Alert:", info);
      switch (info.type) {
        case "closeButton":
          this.setState({ helpShow: false, errorFlg: false, deleteAccountAlert: false, deleteCC: false, modal: false, OKPopupShow: false, alertBlock: false, alertCard: false, alertPayment: false, alertElimination: false, alertModification: false, alertResendemail: false, alertDocument: false, alertRenewservice: false, inScreenPopupShow: false, doesCartExist: false, alertCardValidation: false, cvvGuidAlert: false, })
          break;
        case "actionButton":
          if (info.option1 == "block") {
            this.disableCard();
            this.setState({ modal: false, Active: false, alertBlock: false, Block: true })
            break;
          }
          if (info.option1 == "upload") {
            this.setState({ modal: false, alertDocument: false })
            break;
          }
          if (info.option1 == "cvvOK") {
            this.setState({ modal: false, cvvGuidAlert: false })
            break;
          }
          if (info.option1 == "update") {
            this.setState({ modal: false, alertCard: false, methodView: 2, screenNum: 3 })
            break;
          }
          if (info.option1 == "complete") {
            this.setState({ modal: false, alertPayment: false, allmovFlag: false, screenNum: 2 })
            break;
          }
          if (info.option1 == "modify") {
            this.setState({ modal: false, alertModification: false })
            break;
          }
          if (info.option1 == "modifyAutoRenew") {
            this.setState({ modal: false, alertModificationAutoRenew: false })
            window.location.reload();
          }
          if (info.option1 == "eliminate") {

            break;
          }
          if (info.option1 == "resend") {
            this.setState({ modal: false, alertResendemail: false })
            break;
          }
          if (info.option1 == "renew") {
            this.setState({ modal: false, alertRenewservice: false, renewModal: true })
            break;
          }
          if (info.option1 == "changeEmailOK") {
            return this.props.history.push('/');
          }
          if (info.option2 == "cancel") {
            this.setState({ modal: false, alertRenewservice: false })
            break;
          }
          if (info.option1 == "attention") {
            this.setState({ inScreenPopupShow: false, modal: false, alertCardValidation: false, OKPopupShow: false })
            break;
          }
          if (info.option1 == "modify_profilePhoto") {
            this.setState({ alertModificationProfilePhoto: false, modal: false });
            break;
          }
          if (info.option1 == "continuecart") {
            this.setState({ doesCartExist: false })
            this.getLastState(); // get latest state and recovers user latest stage by navigating
            break;
          }
          if (info.option2 == "deletecart") {
            this.setState({ doesCartExist: false });
            this._creat(1, 'skicart'); // create a new cart by force:1
            break;
          }
          if (info.option1 == "deletaccancel") {
            this.setState({ deleteAccountAlert: false, modal: false })
            break;
          }
          if (info.option2 == "deletaccok") {
            this.setState({ deleteAccountAlert: false })
            this.deleteUser();
            break;
          }
          if (info.option1 == "delCCcancel") {
            this.setState({ deleteCC: false, modal: false })
            break;
          }
          if (info.option2 == "delCCOK") {
            this.setState({ deleteCC: false, modal: false })
            this.deleteCreditCard();
            break;
          }
          if (info.option1 == "retryPayment") {
            this.setState({ alertWrongCCInsertion: false });
            this.openCreditCardForm();
            break;
          }
          if (info.option1 == "errorOK") {
            this.setState({ helpShow: false, errorFlg: false, modal: false })
            break;
          }
          if (info.option1 == "deletedOk") {
            this.setState({ userFeedbackForDeletion: false, modal: false }, () => {
              localStorage.clear();
              cookies.remove('access_token');
              return this.props.history.push('/');
            })
            break;
          }
      }
    });
  }



  //renewing the service that has been expired
  renewService = (coupon_code) => {
    this.setState({ isLoading: true });
    renewService(this, {
      linked_user_id: this.state.activeSkier[0].id,
      voucher_code: coupon_code,
    }).then(async (response) => {
      this.setState({ isLoading: false });
      console.log(response);
      if (response.status == "success") {
        await this.updateActiveSkier();
        this.setState({ voucher: '', renewModal: false, renewVisible: false, resultDetails: false });
        this.setState({ panelType: 2 }, () => {
          this.setState({ panelType: 1 });
        });
        this.handleAlert(tr.t("Operationcompleted"), true);
        return this.props.history.push('/');
      } else {
        this.setState({
          errorFlg: true,
          errmsg: response.message
        });
      }
    });
  }



  // Default browser alert function replacement
  handleAlert = (incomingMsg, notitle) => {
    console.log("Incoming message:", incomingMsg);
    if (notitle) {
      return this.setState({
        OKPopupShow: true,
        inScreenPopupMsg: incomingMsg,
      });
    }
    this.setState({
      inScreenPopupShow: true,
      inScreenPopupMsg: incomingMsg,
    })
  }

  // LOGOUT!
  logout = () => {
    try {
      // fill storage w/ user data.
      userLogoutFetch(this).then((response) => {
        console.log(response);
        localStorage.clear();
        cookies.remove('access_token');
        return this.props.history.push('/');
      });
    } catch (e) {
      console.log(e);
    }
  }


  // blockCard
  disableCard = () => {
    let cardIndex = JSON.parse(localStorage.getItem('cardIndex'));
    let params = {
      linked_user_id: this.state.activeSkier[cardIndex].id,
      code: this.state.activeSkier[cardIndex].code,
    }
    console.log("disableCard", params);

    //call fetch
    disableCardFetch(this, params).then((response) => {
      console.log(response);
      if (response.status == "success") {
        return this.props.history.push('/');
        // this.setState({ panelType: 2 });
        // this.forceUpdate(() => {
        //     this.getCards();
        // });
      } else {
        //handle errors
      }
      // this.setActiveSkier(?); // to refresh skier state ?
    });


  }


  // change user password
  changeUserPassword = () => {
    // @ call changeUserPasswordFetch
    if (this.validatePassword()) {
      console.log('calling change pwd');
      let params = {
        email: this.user.email,
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword
      }
      try {
        changeUserPasswordFetch(this, params).then((response) => {
          console.log(response);
          this.setState({ newPassword: '', newPasswordConfirm: '', oldPassword: '' });
          if (response.status == 'success') {
            this.setState({ profileView: 1 });
            // alert('operazione avvenuta con successo');
            cookies.set("access_token", response.access_token);
            this.handleAlert(tr.t("Operationcompleted"));
          } else {
            // alert(response.message);
            this.handleAlert(response.message);
          }

        });
      } catch (e) {
        console.log(e);
      }
    }
  }


  // change user email
  changeUserEmail = () => {
    if (this.validateEmail()) {
      // onsuccess

      let params = {
        oldEmail: this.state.user.email,
        email: this.state.Emailformnew,
        portal: 'sci',
        one_step: 1,
      }

      try {
        changeEmail(this, params).then((response) => {
          console.log(response);
          if (response.status == 'success') {
            //localStorage.clear();
            let message = response.message;
            try {
              let access_token = cookies.get('access_token');
              userFetch(this, { access_token: access_token }
              ).then((response) => {
                // alert(message);
                // this.handleAlert(message);
                localStorage.setItem('user', JSON.stringify(response));
                return this.props.history.push('/');
                // this.setState({ profileView: 4 })
              });
            } catch (e) {
              console.log(e);
            }
          } else {
            // alert(response.message);
            this.handleAlert(response.message);
          }

        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  //TODO: max 5 skier and each 2 cards!
  // get SKIERS
  // get all skiers and put in storage
  getCards = () => {

    console.log('@call getCards');

    this.forceUpdate(() => {
      //call getCardsFetch
      let params = {
        backoffice: 0,
        email: this.user.email
      }

      try {
        //search user skiers
        getSkiers(this, {
          email: cookies.get('email'),
          backoffice: 0,
          language: this.state.language,
        }).then((skiersResponse) => {

          getCardsFetch(this, params).then((response) => {



            console.log('GETCARDS : ', response);
            console.log('skiers : ', skiersResponse);
            if (typeof response === "undefined") this.logout();
            response.forEach((card) => {
              skiersResponse.forEach((skier) => {
                if (card.id === skier.id) {
                  card.portale = skier.portale;
                }
              });
            });

            if (response.length > 0) {
              let effectiveSkiers = response;
              let groupedSkiers = [];

              const grouped = this.groupBy(effectiveSkiers, skier => skier.id);
              console.log('GETCARDS : grouped', grouped);
              for (const [k, v] of grouped.entries()) {
                console.log("grouped", k, v)
                groupedSkiers.push(v);
              }

              console.log('GETCARDS @groupedSkiers:', groupedSkiers);

              this.setState({ skiers: groupedSkiers });
              this.checkMaxNumUser(groupedSkiers);
              this.setState({ noSkier: false });

            } else {
              this.setState({ noSkier: true });
            }
          });
        });
      } catch (e) {
        console.log(e)
      }

    });
  }
  // check if user reached max number of skiers
  checkMaxNumUser = (skiers) => {
    if (skiers.length >= MAX_SKIERS) {
      this.setState({ maxNumUser: true })
    }
  }


  updateActiveSkier = async () => {
    let email = JSON.parse(localStorage.getItem('email'));
    const cards = await getCardsFetch(this, { email: email, backoffice: 0 });
    const card = cards.filter(card => card.card_id == this.state.activeSkier[0].card_id);
    const skiers = await getSkiers(this, { email: email, backoffice: 0 });
    skiers.forEach((skier) => {
      if (skier.id === card.id) {
        card.portale = skier.portale;
      }
    })
    this.setState({ activeSkier: card });
  }


  // callback from MainPanel
  // switch { minimize / block / renew } state
  mpcallback = (info) => {
    this.forceUpdate(async () => {
      console.log("mpcallback userarea", info)
      switch (info.option) {
        case "minimize":
          this.setState({ panelType: 2 })
          break;
        case "block":
          this.setState({ modal: true, alertBlock: true })
          break;
        case "renew":
          this.setState({ modal: true, renewModal: true, })
          break;
        case "upload":
          //this.setState({ modal:true, alertDocument:true});
          if (info.type) {
            return this.props.history.push(`/upload?type=${info.type}`);
          } else {
            return this.props.history.push('/upload');
          }
        case "replaceCard":
        case "addSecondCard":
          // return this.props.history.push('/welcome');
          return this.addAnotherSkiCard();
        case "cardValidationError":
          this.setState({ cardValidationErrorMsg: info.params, modal: true, alertCardValidation: true });
          break;
        case "autopayModified":
          this.setState({ modal: true, alertModificationAutoRenew: true });
          break;
      }
    });
  }

  addAnotherSkiCard() {
    return this._creat(1, 'skiaddcard');
  }

  // set Expired props for skier
  // check if card has expired
  isExpired = (item) => {
    if (!this.isActivate(item)) {
      let today = new Date();
      let expiration = new Date(item.data_scadenza);
      console.log('ACTIVE: ' + item.id + ' isExpired', (today.getTime() > expiration.getTime()))
      return (today.getTime() > expiration.getTime());
    } else {
      return false
    }
  }


  // set Block props for user
  isBlocked = (item) => {
    return (!!item.card_blocked || !!item.ticket_blocked);


  }

  // set Activate prop 
  isActivate = (item) => {
    return (item.code == '' || item.type == null);
  }

  // check id skier must upload documents
  mustUpload = (item) => {
    return !((item.certified == "1") || this.isAdult(item))
  }

  //if user has not upload documents yet(optional for adult)
  canUpload = (item) => {
    return !item.certified
  }

  // check id skier must upload documents
  isAdult = (item) => {
    console.log("isAdult: ", item);
    return (item.type.toLowerCase() == 'adult')
  }


  // check if Skier must show alert
  // Block  || Upload || Expired || Activate
  hasSkierAlert = (item) => {
    return (
      this.isActivate(item) ||
      this.isBlocked(item) ||
      this.isExpired(item) ||
      this.mustUpload(item)
    );
  }

  // check if card isActive
  // !Block || !Activate
  isActive = (item) => {
    return (!this.isActivate(item) && !this.isBlocked(item));
  }

  // set active skier to show in MainPnl and change view
  setActiveSkier = (index) => {
    console.log(index);
    this.forceUpdate(() => {

      this.getCards();

      this.setState({ activeSkier: this.state.skiers[index] });

      // set default active Skier to show
      localStorage.setItem('activeSkier', JSON.stringify(this.state.skiers[index]));
      this.changemax();
    });
  }


  // USER ACTIONS
  // update user data
  updateUser = (e) => {
    this.forceUpdate(() => {
      e.preventDefault()
      let access_token = cookies.get('access_token');
      try {
        let params = {
          // name: this.state.user.name,
          // surname: this.state.user.surname,
          // date_of_birth: this.state.user.date_of_birth,
          // address: this.state.user.address,
          // address2: this.state.user.address2,
          // zipcode: this.state.user.zipcode,
          // city: this.state.user.city,
          // gender: this.state.user.gender,
          // province: this.state.user.province,
          // country: this.state.user.country,
          // fiscal_code: this.state.fiscal_code,
          // tel_cell: this.state.Phonenumberform,
          // email: this.state.user.email
          tel_cell: this.state.Phonenumberform,
        }
        this.updateActiveSkier();

        updateUser(this, access_token, params).then((response) => {
          console.log("response", response);
          if (response.status == 'success') {
            this.setState({ modal: true, alertModification: true })
            // fill storage w/ user data.
            let access_token = cookies.get('access_token');

            userFetch(this, { access_token: access_token }
            ).then((response) => {
              console.log(response);
              localStorage.setItem('user', JSON.stringify(response));
              //return this.props.history.push('/userarea');
            });
          } else {
            // alert(response.message);
            this.handleAlert(response.message);
          }
        });

      } catch (e) {
        console.error(e);
      }
      // call /users/updateUser
    });

  }

  deleteUser = () => {
    //this.setState({ modal: true, alertElimination: true });
    let params = {
      mail: this.user.email
    };

    deleteUserFetch(this, params).then((response) => {
      console.log("deleteUser:", response);
      if (response.status == "success")
        this.deletionFeedbacktoUser();
      // return this.props.history.push('/');

    });
  }

  //to let user know her account was deleted
  deletionFeedbacktoUser = () => {
    console.log("deletionFeedbacktoUser:");
    //probably is better call logout action, but depends in deleteUser flow. ask to @veronica
    this.setState({
      userFeedbackForDeletion: true, modal: true
    })
  }

  uploadProfilePic = files => {

    console.log('updateporfilePIC!', files);
    this.setState({ isLoading: true, profilePic: files.base64 });

    this.forceUpdate(() => {

      try {
        let params = {
          image: this.state.profilePic.split(',')[1],
          email: this.state.user.email
        }

        updateProfilePictureFetch(this, params).then((response) => {
          console.log("updateProfilePictureFetch", response);
          if (response.status == 'success') {

            this.setState({ modal: true, alertModificationProfilePhoto: true });
            // fill storage w/ user data.
            let access_token = cookies.get('access_token');

            userFetch(this, { access_token: access_token }
            ).then((response) => {
              this.setState({ isLoading: false });
              console.log(response);
              localStorage.setItem('user', JSON.stringify(response));
              this.setState({ user: response });
              // return this.props.history.push('/');
            });
          } else {
            this.setState({ isLoading: false });
            // alert(response.message);
            this.handleAlert(response.message);
          }
        });

      } catch (e) {
        console.error(e);
      }
    }, this);

  }

  // Render Loop skiers MinMainPnl
  // @return MinMainPnl
  renderSkiers = (that) => {
    //TODO: handle user picture if more than 1 ski card exsists
    return this.state.skiers.map(function (item, index) {
      console.log("renderSkiers: ", index, item);
      return <MinMainPnl
        key={index}
        index={index}
        user={item}
        // Upload={this.mustUpload(item[0])}
        // Active={this.isActive(item[0])}
        // Activate={this.isActivate(item[0])}
        // Paganella={false} // @ali @amid when paganella is active?
        // Alert={this.hasSkierAlert(item[0])}
        // Block={this.isBlocked(item[0])}
        onClick={that.setActiveSkier.bind(that)}
        callback={that.changemax.bind(that)}
      />
    }, this);
  }

  renderMovements = (that) => {
    //TODO: handle user picture if more than 1 ski card exsists
    return this.state.skiers.map(function (item, index) {
      return <MovMinMainPnl
        item={item[0]}
        key={index}
        index={index}
        textmov={item[0].name + ' ' + item[0].surname}
        imageProfile={item[0].picture}
        onClick={that.changemovpnl.bind(that)}
        callback={that.changemovpnl.bind(that)}
      />
    });
  }

  getUserProfilePic = () => {

    let pic = '';

    // if (this.state.profilePic != null) {
    //     pic = this.state.profilePic + '?' + Math.random();
    // } else {
    //     pic = (this.state.user.photo ? this.state.user.photo : profilee);
    //     this.setState({ profilePic: pic });
    // }

    pic = (this.state.user.photo ? this.state.user.photo + '?ts=' + Math.random() : profilee);

    console.log('PIC!!!', pic);
    return pic;
  }

  // redirect to resend-mail route
  changeEmail = (e) => {
    this.setState({ profileView: 5 });
    // localStorage.setItem('backto', 'userarea');
    // this.props.history.push({
    //     pathname: '/resend-mail'
    // });
    //profile view 5

  }
  // RESEND EMAIL

  handleResend = (e) => {
    e.preventDefault();
    return this.resendEmailCall(false);
  }

  resendEmailCall(onload) {
    // Rest Call
    try {
      this.setState({ emailCode: '' })
      sendCodeByEmail(this,
        {
          email: this.state.user.email,
          one_step: 1,
          language: tr.userlng().toLowerCase(),
        }).then((response) => {

          console.log("modifyEmail: response: ", response)

          if (response == null) {
            return;
          }
          if (response.status == "fail") {
            console.log("modifyEmail: !!FAIL!!: ", response.message)
            //alert(response.status)
            this.handleAlert(response.status);
            // modify Email
            // send Code By mail
          }
          if (response.status == "success") {
            // alert(tr.t("success"))
            // if (!onload) this.handleAlert(tr.t("success"));
            if (!onload) this.handleAlert(tr.t("EmailSentSuccessfully"), true);
          }
        });

    } catch (e) {
      // alert(e);
      this.handleAlert(e);
    }
  }

  handleNewEmail = (e) => {
    e.preventDefault();
    console.log(e.target.value);
    this.setState({ isEmailValid: validateEmail(e.target.value), modifiedEmail: e.target.value.trim() })
  }

  modifyEmail = () => {
    try {
      let params = {
        oldEmail: this.state.user.email,
        email: this.state.modifiedEmail,
        one_step: 1,
        language: tr.userlng(),
        portal: "sci"
      }
      console.log("modifyEmail: params: ", params)

      modifyEmail(this, params).then((response) => {
        console.log("modifyEmail: response: ", response)

        if (response == null) {
          return;
        }

        if (response.status == "fail") {
          // alert(response.message);
          this.handleAlert(response.message);
          console.log("modifyEmail: !!FAIL!!: ", response.message)

        }
        if (response.status == "success") {
          //  this.handleAlert(tr.t("EmailSentSuccessfully"), true);
          this.setState({ modal: true, changeEmailOK: true });
          // this.setState({ user: { ...this.state.user, email: this.state.modifiedEmail }}, () => {
          //     localStorage.setItem('user', JSON.stringify(user));
          //     this.forceUpdate();
          // });

        }


      });

    } catch (error) {

      // alert(error)
      this.handleAlert(error);
    }
  }

  confirmEmailCode = () => {

    try {
      confirmEmail(this, {
        email: this.state.user.email,
        confirmEmailCode: this.state.emailCode,
        language: tr.userlng().toLowerCase()
      }).then((response) => {
        console.log(response);
        if (response == null) {
          return;
        }
        if (response.status == "fail") {
          this.handleAlert(response.message);
        }
        if (response.status == "success") {
          this.handleAlert(response.message);
          return this.props.history.push('/');
        }

        else {
          // alert(response.message);
          this.handleAlert(response.message);
        }

      });

    } catch (error) {
      console.log('ERROR: ', error);
    }
  }

  /***************WARNING***********
                	
              !!BANK REGION!!

              PLEASE DO NOT TOUCH
  ********************************/

  //this call is used to get the user credit card stored info
  getCreditCardInfo = () => {
    var formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    });
    this.setState({ isLoading: true });
    // this.setState({
    //     errorFlg: false,
    //     errmsg: ""
    // });
    let access_token = cookies.get('access_token');
    let params = { partner_id: 'bitq' }
    getPartnerInfo(this, access_token, params)
      .then((response) => {
        console.log("[Userarea] getPartnerInfo @response: ", response);
        if (response && response.status == 'success' && response.partner && response.partner.length > 0) {
          // partner user
          this.setState({ partner: response.partner });

          if (response.partner.active == 1) {
            this.setState({
              noMethod: false,
              methodView: 3,
              partner_screen_text_accountinfo: 'Account collegato ai Ticket Neve BitQ',
              partner_screen_text_saldo_disponibile: 'Saldo disponibile',
              partner_screen_text_ticketNeve: 'TICKET NEVE',
              partner_screen_text_saldo_disponibile_number: formatter.format(response.partner.wallet_balance),
              partner_screen_text_modalita: 'Modalità',
              partner_screen_text_avviso1: 'Per mantenere le tue card attive è richiesta una disponibilità di almeno ' + formatter.format(response.partner.wallet_minimum_balance) + ' per ciascun sciatore configurato nel tuo profilo.',
              partner_screen_text_avviso2: 'Puoi decidere di scollegare il tuo account Ticket Neve BitQ con apposito pulsante per pagare con carta di credito.',
              partner_screen_text_avviso3: 'NB: ti ricordiamo che puoi usare il tuo saldo solo per attività in linea con i requisiti normativi del Ticket Neve BitQ',
              partner_screen_text_change_from_partner: 'Scollega il Ticket Neve BitQ',
              ccRedAlert: response.partner.wallet_balance < response.partner.wallet_minimum_balance,
            })
          } else {
            this.setState({ partner_screen_text_back_to_partner: 'Riattiva il Ticket Neve BitQ' });
            this.getCCInfo();
          }

          return;
        }
        return this.getCCInfo();
      })

  }

  //this call is used to get the user credit card stored info
  getCCInfo = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    let params = {}

    getCreditCardInfo(this, access_token, params)
      .then((response) => {
        console.log("[Userarea] getCreditCardInfo @response: ", response);
        if (response.id_ut) {
          if (isCreditCardExpired(response.scadenza_contratto)) {
            this.setState({
              ccRedAlert: true,
              alertCard: true,
              modal: true,
            });
          }
          if (response.attiva == 1) {
            this.setState({
              Fullname: (this.state.user.name + " " + this.state.user.surname),
              Banknumber: response.pan.replace(/[xX]/g, "*").substr(0, 4) + " " + response.pan.replace(/[xX]/g, "*").substr(4, 4) + " " + response.pan.replace(/[xX]/g, "*").substr(8, 4) + " " + response.pan.replace(/[xX]/g, "*").substr(12, 4),
              Bankexpiration: response.scadenza_pan.substr(4, 2) + "/" + response.scadenza_pan.substr(2, 2),
              noMethod: false,
              methodView: 1,
            });
          } else {
            this.setState({ noMethod: true, ccRedAlert: true });
          }
        } else {
          this.setState({ noMethod: true, ccRedAlert: true });
          // this.setState({
          //     errorFlg: true,
          //     errmsg: response.message
          // });
        }
      });
    return
  }

  // changing partner activation status from enable to disable and viceversa
  _updateStatusWalletPartner = () => {
    console.log('_updateStatusWalletPartner', this.state.partner, this.state.partner.active);
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    let params = {
      partner_id: 'bitq',
      active: this.state.partner.active == 0 ? 1 : 0
    };
    updateStatusWalletPartner(this, access_token, params)
      .then((response) => {
        console.log("[Userarea] updateStatusWalletPartner @response: ", response);
        if (response && response.status == "success") {
          // this.setState({ noMethod: true, nomethodView: 1 });
          this.getCreditCardInfo();
        } else {
          this.setState({
            errorFlg: true,
            errmsg: response.message
          });
        }
      });
    return
  }

  //to delete user credit card.
  deleteCreditCard = () => {
    this.setState({ isLoading: true });
    let access_token = cookies.get('access_token');
    let params = {};
    deleteCreditCard(this, access_token, params)
      .then((response) => {
        console.log("[Userarea] deleteCreditCard @response: ", response);
        if (response && response.status == "success") {
          this.setState({ noMethod: true, nomethodView: 1 });
        } else {
          this.setState({
            errorFlg: true,
            errmsg: response.message
          });
        }
      });
    return
  }

  onCreditCardChange(event) {
    /*
      Credit Card 	    Sample Number
      Visa 	            4111 1111 1111 1111
      MasterCard        5500 0000 0000 0004
      American Express 	3400 0000 0000 009
      Diner's Club      3000 0000 0000 04
      Carte Blanche     3000 0000 0000 04
      Discover          6011 0000 0000 0004
      en Route          2014 0000 0000 009
      JCB               3088 0000 0000 0009
    */

    console.log('card event.target.rawValue:', event.target.rawValue);
    this.setState({ cardNumber: event.target.rawValue, errCCNumber: false });
    let cardType = creditCardType(event.target.rawValue);
    console.log('cardType: ', cardType);
    this.setState({ ccType: event.target.rawValue.length > 0 && cardType && cardType[0] ? cardType[0].niceType : '' });
  }

  onCVVchange(event) {
    // // formatted pretty value
    // console.log(event.target.value);
    // raw value
    console.log(event.target.rawValue);
    this.setState({ cvv: event.target.rawValue, errCvv: false });

  }

  onqmarkClicked = () => {
    return this.setState({ modal: true, cvvGuidAlert: true })
  }

  // gestPayCallback = (data) => {
  //     // let data = JSON.parse(e.data);
  //     console.log("[userarea] @gestPayCallback #data", data);
  //     this.setState({gestpay:false});
  //     if (data.status.indexOf('_OK') !== -1) {
  //         //payment successful
  //         this.setState({ isLoading: false, });
  //         this.getCreditCardInfo();
  //         console.log("BANK TRANSACTION: OK!", data.status, data.data);
  //         // go to cc part
  //         this.setState({
  //             screenNum: 3,
  //         });

  //     }
  //     if (data.status.indexOf('_KO') !== -1) {
  //         this.setState({ isLoading: false });
  //         //ERROR in payment
  //         // go to cc part
  //         // and open the cc insertion screen
  //         this.setState({
  //             screenNum: 3,
  //             nomethodView: 2,
  //         });
  //     }

  //     // if (data.status.indexOf('_ERROR') !== -1) {
  //     //     this.setState({ isLoading: false });
  //     //     //ERROR in payment
  //     //     console.log("BANK TRANSACTION: ERROR!", data.status, data.data);
  //     //     this.setState({ bankErrMsg: data.data ? data.data : this.state.bankErrMsg, alertWrong: true });
  //     // }
  // }

  handleChangeHolderName = (e) => {
    e.preventDefault();
    this.setState({
      cardHolder: e.currentTarget.value,
      errCardHolderName: false
    });
    console.log("[Insericredito] handleChangeHolderName:  ", e.currentTarget.value);
  }

  BankalertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ modal: false, alertWrong: false })
        break;
      case "actionButton":
        if (info.option1 == "retry") {
          this.setState({ modal: false, alertWrong: false })
          break;
        }
    }

  }


  convertToISO88591(payloadString) {
    const iso88591Payload = payloadString.replace(/[^\x00-\xFF]/g, (char) => {
      return `&#${char.charCodeAt(0)};`;
    });
    return iso88591Payload;
  }

  preparePostData = (payload) => {
    const payloadString = Object.keys(payload)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
      .join('&');
    const iso88591Payload = this.convertToISO88591(payloadString);

    return iso88591Payload;
  };

  onSubmitBankRequest(paymentType) {
    this.setState({ isLoading: true, paymentType: paymentType });
    let params = {
      bank: {
        shopLogin: Config.bank.shopLogin,
        portal: Config.bank.portal,
        test: Config.bank.test
      },
      userId: this.state.user.id_ut,
      paymentType: paymentType,
      amountCents: this.state.totalPrice * 100, //In case of edit or insertion, will be handled by bank
      checked: this.state.tokenized,
      configTest: Config.test,
      token: cookies.get('access_token'),
      EXPMM: this.state.mm.padStart(2, "0"),
      EXPYY: this.state.yyyy.substr(2, 2),
      CC: this.state.cardNumber,
      CVV2: this.state.cvv,
      BuyerName: this.state.cardHolder,
      lang: tr.userlng(),
    }
    console.log("[Userarea] onSubmitBankRequest @params:  ", params);
    this.setState({ gestpay: true, gestpayParams: params });
  }

  //validating credit card info in user level

  validateCCInfo = (e) => {
    e.persist()
    const { id, value, rawValue } = e.target
    console.log(id, value, rawValue);
    switch (id) {
      case "ccNumber":
        console.log("[Userarea] states :" + rawValue.length);
        this.setState({ errCCNumber: !(rawValue.length == 16) }, () =>
          this.checkCCInfo());
        break;
      case "cardHolder":
        this.setState({ errCardHolderName: !(value.trim().length > 0) }, () =>
          this.checkCCInfo());
        break;
      case "cvv":
        this.setState({ errCvv: !(parseInt(rawValue) > 0) }, () =>
          this.checkCCInfo());
        break;
      default:
        break;
    }
  }

  //disable/enable the "save" button!
  checkCCInfo = () => {
    return this.setState({ ccInfoErr: (this.state.errCCNumber || this.state.errCardHolderName || this.state.errCvv) });
  }

  /*********END OF BANK AREA********/

  onMobileTurnOnSito = () => {
    try {

      // fill storage w/ user data.
      userLogoutFetch(this).then((response) => {
        console.log(response);
        localStorage.clear();
        cookies.remove('access_token');
        window.open('https://www.mypass.ski', "_blank")
        return this.props.history.push('/');
      });
    } catch (e) {
      console.log(e);
    }
  }

  onThirdPartyClicked = () => {
    // enable -> disable
    if (this.state.partner.active == 1) {
      this.setState({
        showThirdPartyAlert: true,
        thirdPartyAlertTitle: 'Cambia metodo di pagamento',
        thirdPartyAlertMessage: 'Vuoi passare al pagamento tramite carta di credito?\nPotrai ricollegarti al Ticket Neve BitQ in seguito.',
        thirdPartyAlertFirstButton: 'Conferma',
        thirdPartyAlertScondButton: 'Annulla',
        thirdPartyAlertOption1: '0',
      })
    } else {
      // disable -> enable
      this.setState({
        showThirdPartyAlert: true,
        thirdPartyAlertTitle: 'Cambia metodo di pagamento',
        thirdPartyAlertMessage: 'Vuoi passare al pagamento tramite Ticket Neve BitQ?\nPotrai tornare al pagamento con carta di credito in seguito.',
        thirdPartyAlertFirstButton: 'Conferma',
        thirdPartyAlertScondButton: 'Annulla',
        thirdPartyAlertOption1: '1',
      })
    }

    //    
  }

  onthirdPartCallback = (e) => {
    this.setState({ showThirdPartyAlert: false })
    console.log('onthirdPartCallback', e);
    switch (e.option1) {
      case '0':
      case '1':
        this._updateStatusWalletPartner();
        break;
      default:
        break;
    }
  }


  onAlert = () => {
    //go to payment method..
    this.setState({ screenNum: 3 });
  }


  goToReservation(to) {
    let access_token = cookies.get('access_token');
    if (access_token) {
      let uri = "";
      uri += `https://user${Config.test == 1 ? "-test" : ""}.mypass.ski/reservation/${to == "wallet" ? "wallet.html" : ""}?`;
      uri += `source=web`;
      uri += `&access_token=${access_token}`;
      uri += `&wf=skires`;
      uri += `&platform=${Config.platform}`;
      uri += `&test=${Config.test}`;
      uri += `&lan=${tr.userlng().toLowerCase()}`;
      uri += `&valid=1`;
      uri += `&ts=${Math.random()}`;
      window.location.href = uri;
    }
  }
  handleClose = () => {
    this.setState({ renewModal: false, })
  }

  getRenewServicePrice = () => {
    console.log('getRenewServicePrice request', this.state.user);
    let params = {
      service: "sci",
      type: 'renew',
      date_of_birth: this.state.user.data_nasc
    }
    let access_token = cookies.get('access_token');
    getServicePrice(this, access_token, params)
      .then((response) => {
        console.log('getRenewServicePrice', response);
        if (response == "fail" || response < 0) {
          this.setState({ renewModal: false });
          Alert.error(tr.t('ErrorRenewService'));
        } else {
          this.setState({ renewServicePrice: response });
        }
      });
  }

  handleVerifyCoupon = () => {
    validateCoupon(this, this.state.voucher.toUpperCase()).then((coupon) => {
      console.log('validateCoupon', coupon);
      if (coupon.status !== "success") {
        this.setState({
          validVoucher: false,
          resultDetails: true,
          failureMessage: coupon.message,
          renewEnabled: false,
          successMessage: false
        });
      } else {
        const discount = coupon.type === "percentage" ? parseFloat(this.props.price) * parseFloat(coupon.amount) / 100 : parseFloat(coupon.amount);
        this.setState({
          successMessage: true,
          resultDetails: true,
          validVoucher: true,
          discount: discount,
          renewEnabled: true,
        });
      }
    });
  }


  renderRenewModal() {
    return (
      <div className="modalContainer">
        <div className="gradientBackground">
          <div className="modalContent">
            <div className="subContent">
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <button onClick={() => this.setState({ renewModal: false, modal: false, voucher: '', resultDetails: false })} style={{ backgroundColor: 'transparent', border: 0, boxShadow: 0 }}>
                  <img className="img-fluid" width={'30'} height={'30'} src={close} />
                </button>
              </div>
              <p style={{ fontWeight: 300, textAlign: 'center', fontSize: '20px', color: 'white', }}>{tr.t('AlertRenew').replace('%{price}', this.state.renewServicePrice)}</p>
              <p style={{ fontWeight: 'bold', fontSize: '15px', color: 'white' }}>{tr.t('DoYouHaveCoupon')}</p>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <input
                  style={{ width: '70%', height: '40px', borderBottomColor: 'white', borderBottomWidth: '1px', padding: '0 10px', color: 'white' }}
                  type="text"
                  value={this.state.voucher.toUpperCase()}
                  placeholder="Voucher"
                  onChange={(e) => {
                    this.setState({ voucher: e.target.value.trim(), failureMessage: '', renewEnabled: true });
                  }}
                />
                <button
                  class="sn_btn sn_minibutton"
                  onClick={() => this.handleVerifyCoupon()}
                  disabled={!this.state.voucher.length > 0}
                >
                  {tr.t('Verify')}
                </button>
              </div>
              <div style={{ height: 80, display: 'flex', flexDirection: 'column', alignSelf: 'flex-start', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                {
                  this.state.resultDetails &&
                    this.state.validVoucher ?
                    <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'flex-start', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                      <p style={{ color: 'white', fontWeight: 'bold', fontFamily: 'italic' }}>{tr.t('ValidCouponFor')}: <span style={{ color: 'white', fontWeight: 'bold' }}>{` €${this.state.discount.toFixed(2)}`}</span></p>
                      <p style={{ color: 'white', fontWeight: 'bold', fontFamily: 'italic' }}>{tr.t('TotalToPay')}: <span style={{ color: 'white', fontWeight: 'bold' }}>{` €${(parseInt(this.state.renewServicePrice) - this.state.discount).toFixed(2)}`}</span></p>
                    </div>
                    :
                    <p style={{ color: 'red', display: 'flex', flexDirection: 'row', alignSelf: 'flex-start' }}>{this.state.failureMessage}</p>
                }
                  </div>
                <button
                  class="sn_btn sn_minibutton"
                  onClick={() => {
                    this.setState({ renewModal: false });
                    this.renewService();
                  }}
                >
                  {tr.t('Renew')}
                </button>
            </div>

            {/* <div className="subContent"> */}
            {/* {this.state.validVoucher ? (
                  <div style={!this.state.successMessage ? 'display: none;' : ''}>
                    <p style={{ fontWeight: 'bold' }}>ValidCouponFor: <span style={{ fontWeight: 'bold' }}>€{this.state.discount}{Config.language === 'it' ? ',00' : '.00'}</span></p>
                    <p style={{ fontWeight: 'bold' }}>TotalToPay: <span style={{ fontWeight: 'bold' }}>€{parseInt(this.props.price) - this.state.discount}{Config.language === 'it' ? ',00' : '.00'}</span></p>
                  </div>
                ) : (
                  <p style={!this.state.failureMessage ? 'display: none;' : ''}>{this.state.failureMessage}</p>
                )}
                {<button disabled={!this.state.renewEnabled} onClick={() => this.renewService(this.state.voucher)}>
                  Next
                </button>} */}
            {/* </div> */}
          </div>
        </div>
      </div>
    );
  }

  render() {
    // console.log("[Userarea] states:", this.state.errCCNumber, this.state.errCardHolderName , this.state.errCvv);
    return (
      <Router>
        <div>
          {
            this.state.renewModal && this.renderRenewModal()
          }
          {
            this.state.loadedData && <div>
              {/* {true && <div> */}
              <BrowserView>
                <div className="sn_tempLvl" style={this.state.renewModal ? { backgroundColor: 'rgba(0, 0, 0, 0.4)', opacity: 0.5 } : {}}>
                  <div className="sn_ua__overlay"></div>
                  <div className="container-fluid">
                    <div className="row my-5">
                      <div className="col-12">
                        <img className="sn_mobile_top_row_logo" src={logo} alt="" />
                      </div>
                    </div>
                  </div>
                  {/*
										<div className="sn_header">
											<div className="container-fluid">
												<div className="row">
													<div className="col">
														<div className="row">
															<div className="col px-3 px-sm-5 pt-4 pt-xl-3">
																<div className="sn_header_logo">
																	<img src={mypassci} className="img-fluid" />
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									*/}
                  {
                    this.state.screenNum == 1 ?
                      <div className="sn_body mx-auto">
                        <div className="container-md">
                          {/* profile */}
                          <div className="row">
                            <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                              <div className="sn_user d-flex align-items-center">
                                <div className="sn_user_profile">
                                  <button className="profileBtn" onClick={this.change0}></button>
                                  <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                </div>
                                <div className="sn_user_fullname sn_heading">
                                  {this.state.user.name} {this.state.user.surname}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* profile */}
                          <div className="row mt-3">
                            <div className="col-auto sn_sidebar mb-3 mb-lg-0">
                              <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={true} />
                              {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                              {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                              <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={false} />
                              <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={false} />
                              <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={false} />
                              <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={false} />
                              <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                              {/*
															<div className="logOut">
																<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
															</div>
														*/}
                            </div>
                            <div className="col d-flex justify-content-center">
                              {
                                !this.state.noSkier ?
                                  <div className="w-100">
                                    {/* SKIER PANEL */}
                                    {
                                      this.state.panelType == 1 ?
                                        <div className="w-100">
                                          <div className="w-100">
                                            <MainPnl
                                              user={this.state.activeSkier}
                                              mpcallback={this.mpcallback}
                                            />
                                            {/* <div className="marginBottom"></div> */}
                                          </div>
                                        </div> : null
                                    }
                                    {/* LIST SKIERS  */}
                                    {
                                      this.state.panelType == 2 ?
                                        <div className="w-100">
                                          <div className="w-100">
                                            {this.renderSkiers(this)}
                                            {
                                              !this.state.maxNumUser ?
                                                <div className="d-flex justify-content-center mt-4">
                                                  <button onClick={this.handleAddNewSkier} className="sn_btnUa">{tr.t("Addnew")}</button>
                                                </div> : null
                                            }
                                            {/* <div className="marginBottom"></div> */}
                                          </div>
                                        </div> : null
                                    }
                                  </div> : null
                              }
                              {
                                this.state.noSkier ?
                                  <div className="w-100 d-flex flex-column align-items-center">
                                    <div className="w-100 sn_ua__container text-center mb-5 p-4 p-sm-5">{tr.t("Nouser")}</div>
                                    <button className="sn_btnUa mx-auto px-5" onClick={this.handleAddNewSkier}>{tr.t("Addnew")}</button>
                                    {/* <div className="marginBottom"></div> */}
                                  </div> : null
                              }
                            </div>
                          </div>
                        </div>
                      </div> : null
                  }
                  {/* LIST MOVIMENTI  */}
                  {
                    this.state.screenNum == 2 ?
                      <div className="sn_body mx-auto">
                        <div className="container-md">
                          {/* profile */}
                          <div className="row">
                            <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                              <div className="sn_user d-flex align-items-center">
                                <div className="sn_user_profile">
                                  <button className="profileBtn" onClick={this.change0}></button>
                                  <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                </div>
                                <div className="sn_user_fullname sn_heading">
                                  {this.state.user.name} {this.state.user.surname}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* profile */}
                          <div
                            className="row mt-3"
                            style={{
                              display: 'flex',
                            }}
                          >
                            <div className="col-auto">
                              <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={false} />
                              {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                              {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                              <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={true} />
                              <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={false} />
                              <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={false} />
                              <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={false} />
                              <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                              {/*
															<div className="logOut">
																<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
															</div>
														*/}
                            </div>
                            <div
                              className="col d-flex flex-column align-items-center"
                              style={{ width: window.innerWidth * 0.1 }}
                            >
                              {this.state.movFlag && this.state.allmovFlag ?
                                <div className="w-100">
                                  {this.renderMovements(this)}
                                  <AllMovMinMainPnl onClick={this.changeallmovpnl} />
                                </div> : null
                              }
                              {!this.state.movFlag ?
                                <div className="w-100">
                                  <MovSubPnl activeSkier={this.state.selectedSkier} lastName={this.state.lastName} onClick={this.changemovpnl} onAlert={this.onAlert} />
                                </div> : null
                              }
                              {!this.state.allmovFlag ?
                                <div className="w-100 h-100">
                                  <AllMovPnl lastName={this.state.lastName} onClick={this.changeallmovpnl} />
                                </div> : null
                              }
                            </div>
                          </div>
                        </div>
                      </div> : null
                  }
                  {/* PAYMENT METHOD  */}
                  {
                    this.state.screenNum == 3 ?
                      <div className="sn_body mx-auto">
                        <div className="iframe" style={{ visibility: this.state.iframeVisible, display: "none" }}>
                          <iframe
                            ref={(f) => this.ifr = f}
                            //sandbox="allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation allow-scripts allow-popups allow-forms"
                            style={{ width: '100%', height: '100%' }}
                            src={Config.merchantURL}
                          />
                        </div>
                        <div className="container-md">
                          {/* profile */}
                          <div className="row">
                            <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                              <div className="sn_user d-flex align-items-center">
                                <div className="sn_user_profile">
                                  <button className="profileBtn" onClick={this.change0}></button>
                                  <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                </div>
                                <div className="sn_user_fullname sn_heading">
                                  {this.state.user.name} {this.state.user.surname}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* profile */}
                          <div className="row mt-3">
                            <div className="col-auto">
                              <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={false} />
                              {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                              {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                              <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={false} />
                              <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={true} />
                              <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={false} />
                              <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={false} />
                              <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                              {/*
															<div className="logOut">
																<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
															</div>
														*/}
                            </div>
                            <div className="col">
                              {
                                !this.state.noMethod ?
                                  <div className="row">
                                    {/* there is a registred credit card */}
                                    {
                                      this.state.methodView == 1 ?
                                        <div className="col">
                                          <div className="sn_ua__container p-4 p-md-5">
                                            <div className="row justify-content-between">
                                              <div className="col-auto">
                                                <div className="row mb-4">
                                                  <div className="col">
                                                    <div className="methodpic">
                                                      <img src={crdcredit} className="img-fluid" />
                                                    </div>
                                                  </div>
                                                  <div className="col-auto">
                                                    <h5>{this.state.Banknumber}</h5>
                                                    <h6>{this.state.Bankexpiration}</h6>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col d-flex flex-column flex-md-row justify-content-end align-items-md-end">
                                                <button className="sn_btn mr-md-3 mb-3 mb-md-0" onClick={this.handleEdit}>{tr.t("Edit")}</button>
                                                <button className="sn_btn" onClick={this.handleDelete}>{tr.t("Delete")}</button>
                                                {
                                                  this.state.partner &&
                                                  <button className="back-to-btq-button btnFit" onClick={() => { this.onThirdPartyClicked() }}>{this.state.partner_screen_text_back_to_partner}</button>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div> : null
                                    }
                                    {/* Edit credit card */}
                                    {
                                      this.state.methodView == 2 ?
                                        <div className="col">
                                          <div className="sn_ua__container p-4 p-sm-5">
                                            <div className="profilePnl">
                                              <div className="row">
                                                <div className="col-12">

                                                  <div className="row">
                                                    <div className="col-12">
                                                      <h5 className="mb-5">{tr.t("Nomethodinput")}</h5>
                                                      <div className="sn_credit__container__rectangle">
                                                        {
                                                          this.state.cardNumber &&
                                                          <label htmlFor="ccNumber" className="top-label">
                                                            {tr.t("Cardnum")}
                                                          </label>
                                                        }
                                                        <div className="sn_credit__container__wrap">
                                                          <div className="sn_credit__container__retangle__wrap__cards">
                                                            <img src={this.state.ccType === 'Visa' ? visacard : this.state.ccType === 'Mastercard' ? mastercard : masterviza} />
                                                          </div>
                                                          <Cleave
                                                            id="ccNumber"
                                                            style={{ borderColor: this.state.errCCNumber ? 'red' : '' }}
                                                            className="sn_credit__container__wrap__input"
                                                            placeholder={tr.t("Cardnum")}
                                                            options={{ creditCard: true }}
                                                            onFocus={this.onCreditCardFocus}
                                                            onChange={this.onCreditCardChange}
                                                            onBlur={(e) => { this.validateCCInfo(e) }}
                                                          />
                                                        </div>
                                                        {
                                                          this.state.errCCNumber &&
                                                          <div className="error">
                                                            {tr.t("CCNumberIsWrong")}
                                                          </div>
                                                        }
                                                      </div>
                                                      <div className="sn_credit__container__rectangle">
                                                        {
                                                          this.state.cardHolder &&
                                                          <label htmlFor="cardHolder" className="top-label">
                                                            {tr.t("Fullnameinput")}
                                                          </label>
                                                        }
                                                        <input
                                                          id="cardHolder"
                                                          style={{ borderColor: this.state.errCardHolderName ? 'red' : '' }}
                                                          onBlur={(e) => { this.validateCCInfo(e) }}
                                                          type="text"
                                                          name="name"
                                                          placeholder={tr.t("Fullnameinput")}
                                                          onChange={this.handleChangeHolderName}
                                                          className="sn_credit__container__wrap__input"
                                                          maxLength="50"
                                                        />
                                                        {
                                                          this.state.errCardHolderName &&
                                                          <div className="error">
                                                            {tr.t("CCHolderNameIsWrong")}
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="row mb-5">
                                                    <div className="col-12 col-sm-6 d-flex align-items-center mt-5 mt-sm-0">
                                                      <div className="sn_credit__container__rectangle w-100">
                                                        <MonthPicker
                                                          defaultValue={tr.t("Month")}
                                                          numeric
                                                          //short
                                                          endYearGiven
                                                          year={this.state.year}
                                                          required={false}
                                                          disabled={false}
                                                          value={this.state.month}
                                                          onChange={(month) => {
                                                            if (month) {
                                                              this.setState({ mm: (Number(month) + 1).toString() });
                                                              //console.log((Number(month) + 1).toString());
                                                            }
                                                            else {
                                                              this.setState({ mm: "" });
                                                            }
                                                          }}
                                                          id={'month'}
                                                          name={'month'}
                                                          classes={'date-button month'}
                                                          optionClasses={'opbtnit'}

                                                        />
                                                        <YearPicker
                                                          defaultValue={tr.t("Year")}
                                                          start={this.CCStartYear}
                                                          end={this.CCEndYear}
                                                          required={false}
                                                          disabled={false}
                                                          value={this.state.year}
                                                          onChange={(year) => {
                                                            this.setState({ yyyy: year });
                                                            //console.log(year);
                                                          }}
                                                          id={'year'}
                                                          name={'year'}
                                                          classes={'date-button year'}
                                                          optionClasses={'opbtnit'}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                      <div className="sn_credit__container__rectangle">
                                                        {
                                                          this.state.cvv &&
                                                          <label htmlFor="cvv" className="top-label">
                                                            {tr.t("Cvv")}
                                                          </label>
                                                        }
                                                        <Cleave
                                                          id="cvv"
                                                          style={{ borderColor: this.state.errCvv ? 'red' : '' }}
                                                          className="sn_credit__container__wrap__input"
                                                          placeholder={tr.t("Cvv")}
                                                          maxLength="3"
                                                          options={{ blocks: [3], uppercase: true }}
                                                          value={this.state.code}
                                                          onChange={this.onCVVchange}
                                                          onBlur={(e) => { this.validateCCInfo(e) }}
                                                        />
                                                        <div>
                                                          {
                                                            !this.state.cvv &&
                                                            <div className="info-quest">
                                                              <a onClick={() => this.onqmarkClicked()}>
                                                                <img src={qmark} />
                                                              </a>
                                                            </div>
                                                          }
                                                          {
                                                            this.state.errCvv &&
                                                            <div>
                                                              <div className="error">
                                                                {tr.t("CCCvvIsWrong")}
                                                              </div>
                                                            </div>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="row">
                                                    <div className="col d-flex flex-column flex-md-row justify-content-end align-items-md-end">
                                                      <button className="sn_btn mr-md-3 mb-3 mb-md-0" onClick={this.handleSavem}>{tr.t("Save")}</button>
                                                      <button className="sn_btn" onClick={this.handleCancelm}>{tr.t("Cancel")}</button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div> : null
                                    }
                                    {/* there is a 3rd-party credit*/}
                                    {
                                      this.state.methodView == 3 ?
                                        <div className="col">
                                          <div className="sn_ua__container p-4 p-sm-5">
                                            <p>
                                              {this.state.partner_screen_text_accountinfo}
                                            </p>
                                            <div className="row">
                                              <div className="col-12 col-md-auto order-2 order-md-1">
                                                <div className="third-party-heading-column1">
                                                  {this.state.partner_screen_text_saldo_disponibile}
                                                </div>
                                                <div className="third-party-heading">
                                                  <div className="third-party-heading-column-price">
                                                    {this.state.partner_screen_text_saldo_disponibile_number}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-12 col-md order-1 order-md-2 d-flex justify-content-end mb-5 mb-md-0">
                                                <div>
                                                  <div className="third-party-heading-column2-text">
                                                    {this.state.partner_screen_text_ticketNeve}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              <div className="third-party-modalita-bold">{this.state.partner_screen_text_modalita}</div>
                                              <div className="third-party-modalita-text">{this.state.partner_screen_text_avviso1}</div>
                                              <div className="third-party-modalita-text">{this.state.partner_screen_text_avviso2}</div>
                                            </div>
                                            <div className="mt-5">
                                              <div className="third-party-modalita-NB mb-5" >{this.state.partner_screen_text_avviso3}</div>
                                              <div>
                                                <button onClick={() => { this.onThirdPartyClicked() }} className="sn_btn" >{this.state.partner_screen_text_change_from_partner}</button>
                                              </div>
                                            </div>
                                          </div>
                                        </div> : null
                                    }
                                  </div> : null
                              }

                              {/* There is no credit card  */}
                              {this.state.noMethod ?
                                /*<div className={"row" + (this.state.nomethodView == 1 ? ' h-100' : '' ) }>*/
                                <div className="row">
                                  {/* shows a message that says user need to insert credit card */}

                                  {
                                    this.state.nomethodView == 1 ?
                                      <div className="col">
                                        <div className="sn_ua__container p-4 p-sm-5 w-100">
                                          <div className="col d-flex flex-column justify-content-center align-items-center">
                                            <p className="mb-5">{tr.t("Nomethod")}</p>
                                            {
                                              !this.state.partner &&
                                              <button className="sn_btn" onClick={this.handleInsert}>{tr.t("Insertm")}</button>
                                            }
                                            {
                                              !!this.state.partner &&
                                              <div className="insert-and-btq">
                                                <button className="sn_btn" onClick={this.handleInsert}>{tr.t("Insertm")}</button>
                                                <button className="sn_btn" onClick={() => { this.onThirdPartyClicked() }}>{this.state.partner_screen_text_back_to_partner}</button>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div> : null
                                  }
                                  {/* Inserting credit card*/}

                                  {
                                    this.state.nomethodView == 2 ?
                                      <div className="col">
                                        <div className="sn_ua__container p-4 p-lg-5">
                                          <div className="profilePnl">
                                            <div className="row mb-3 mb-lg-0">
                                              <div className="col d-flex justify-content-end">
                                                <a className="sn_exit" onClick={() => { this.setState({ nomethodView: 1 }) }}>
                                                  <img className="img-fluid" src={close} />
                                                </a>
                                              </div>
                                            </div>
                                            <div className="row mx-md-5">
                                              <div className="col-12">
                                                <div className="row">
                                                  <div className="col-12">
                                                    <h5 className="mb-5">{tr.t("Nomethodinput")}</h5>
                                                    <div className="sn_credit__container__rectangle">
                                                      {
                                                        this.state.cardNumber &&
                                                        <label htmlFor="ccNumber" className="top-label">
                                                          {tr.t("Cardnum")}
                                                        </label>
                                                      }
                                                      <div className="sn_credit__container__wrap">
                                                        <div className="sn_credit__container__retangle__wrap__cards">
                                                          <img src={this.state.ccType === 'Visa' ? visacard : this.state.ccType === 'Mastercard' ? mastercard : masterviza} />
                                                        </div>
                                                        <Cleave
                                                          id="ccNumber"
                                                          style={{ borderColor: this.state.errCCNumber ? 'red' : '' }}
                                                          className="sn_credit__container__wrap__input"
                                                          placeholder={tr.t("Cardnum")}
                                                          options={{ creditCard: true }}
                                                          onFocus={this.onCreditCardFocus}
                                                          onChange={this.onCreditCardChange}
                                                          onBlur={(e) => { this.validateCCInfo(e) }}
                                                        />
                                                      </div>
                                                      {
                                                        this.state.errCCNumber &&
                                                        <div className="error">
                                                          {tr.t("CCNumberIsWrong")}
                                                        </div>
                                                      }
                                                    </div>
                                                    <div className="sn_credit__container__rectangle">
                                                      {
                                                        this.state.cardHolder &&
                                                        <label htmlFor="cardHolder" className="top-label">
                                                          {tr.t("Fullnameinput")}
                                                        </label>
                                                      }
                                                      <input
                                                        id="cardHolder"
                                                        style={{ borderColor: this.state.errCardHolderName ? 'red' : '' }}
                                                        onBlur={(e) => { this.validateCCInfo(e) }}
                                                        type="text"
                                                        name="name"
                                                        placeholder={tr.t("Fullnameinput")}
                                                        onChange={this.handleChangeHolderName}
                                                        className="sn_credit__container__wrap__input"
                                                        maxLength="50"
                                                      />
                                                      {
                                                        this.state.errCardHolderName &&
                                                        <div className="error">
                                                          {tr.t("CCHolderNameIsWrong")}
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row mb-5">
                                                  <div className="col-12 col-sm-6 d-flex align-items-center mt-5 mt-sm-0">
                                                    <div className="sn_credit__container__rectangle w-100">
                                                      <MonthPicker
                                                        defaultValue={tr.t("Month")}
                                                        numeric
                                                        //short
                                                        endYearGiven
                                                        year={this.state.year}
                                                        required={false}
                                                        disabled={false}
                                                        value={this.state.month}
                                                        onChange={(month) => {
                                                          if (month) {
                                                            this.setState({ mm: (Number(month) + 1).toString() });
                                                            //console.log((Number(month) + 1).toString());
                                                          }
                                                          else {
                                                            this.setState({ mm: "" });
                                                          }
                                                        }}
                                                        id={'month'}
                                                        name={'month'}
                                                        classes={'date-button month'}
                                                        optionClasses={'opbtnit'}
                                                      />
                                                      <YearPicker
                                                        defaultValue={tr.t("Year")}
                                                        start={this.CCStartYear}
                                                        end={this.CCEndYear}
                                                        required={false}
                                                        disabled={false}
                                                        value={this.state.year}
                                                        onChange={(year) => {
                                                          this.setState({ yyyy: year });
                                                          //console.log(year);
                                                        }}
                                                        id={'year'}
                                                        name={'year'}
                                                        classes={'date-button year'}
                                                        optionClasses={'opbtnit'}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-12 col-sm-6">
                                                    <div className="sn_credit__container__rectangle">
                                                      {
                                                        this.state.cvv &&
                                                        <label htmlFor="cvv" className="top-label">
                                                          {tr.t("Cvv")}
                                                        </label>
                                                      }
                                                      <Cleave
                                                        id="cvv"
                                                        style={{ borderColor: this.state.errCvv ? 'red' : '' }}
                                                        className="sn_credit__container__wrap__input"
                                                        placeholder={tr.t("Cvv")}
                                                        maxLength="3"
                                                        options={{ blocks: [3], uppercase: true }}
                                                        value={this.state.code}
                                                        onChange={this.onCVVchange}
                                                        onBlur={(e) => { this.validateCCInfo(e) }}
                                                      />
                                                      <div>
                                                        {
                                                          !this.state.cvv &&
                                                          <div className="info-quest">
                                                            <a onClick={() => this.onqmarkClicked()}>
                                                              <img src={qmark} />
                                                            </a>
                                                          </div>
                                                        }
                                                        {
                                                          this.state.errCvv &&
                                                          <div>
                                                            <div className="error">
                                                              {tr.t("CCCvvIsWrong")}
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row mt-5">
                                                  <div className="col d-flex flex-column flex-md-row align-items-center justify-content-center">
                                                    <button disabled={this.state.ccInfoErr} className="sn_btn" onClick={this.handleSave}>{tr.t("Save")}</button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> : null
                                  }
                                </div> : null
                              }
                            </div>
                          </div>
                        </div>
                      </div> : null
                  }

                  {/* PRIVACY   */}
                  {
                    this.state.screenNum == 4 ?
                      <div className="sn_body mx-auto">
                        <div className="container-md">
                          {/* profile */}
                          <div className="row">
                            <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                              <div className="sn_user d-flex align-items-center">
                                <div className="sn_user_profile">
                                  <button className="profileBtn" onClick={this.change0}></button>
                                  <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                </div>
                                <div className="sn_user_fullname sn_heading">
                                  {this.state.user.name} {this.state.user.surname}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* profile */}
                          <div className="row mt-3">
                            <div className="col-auto">
                              <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={false} />
                              {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                              {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                              <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={false} />
                              <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={false} />
                              <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={true} />
                              <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={false} />
                              <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                              {/*
													<div className="logOut">
														<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
													</div>
												*/}
                            </div>
                            <div className="col d-flex flex-column align-items-center justify-content-start">
                              <div className="sn_ua__container p-4 p-sm-5">
                                <p className="mb-4 text-center">
                                  {tr.t("Initialcookiesprivacy")}
                                </p>
                                <div className="row mb-5">
                                  <div className="col-12 col-md-6 col-lg-4 offset-lg-2 d-flex justify-content-start justify-content-md-center mb-2 mb-md-0">
                                    <form>
                                      <label className={this.state.radio1p ? "containerrdhut" : "containerrdhub"}>
                                        {(tr.t("Agree"))}
                                        <input checked={this.state.radio1p} type="radio" name="radio" onChange={this.radio1p} />
                                        <span className="checkmarku"></span>
                                      </label>
                                      <div className="spaceRadio" />
                                    </form>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4 d-flex justify-content-start justify-content-md-center">
                                    <form>
                                      <label className={this.state.radio2p ? "containerrdhut" : "containerrdhub"}>
                                        {(tr.t("Nagree"))}
                                        <input checked={this.state.radio2p} type="radio" name="radio" onChange={this.radio2p} />
                                        <span className="checkmarku"></span>
                                      </label>
                                    </form>
                                  </div>
                                </div>
                                <p className="mb-4 text-center">
                                  {tr.t("Initialdataprivacy")}
                                </p>
                                <div className="row mb-5">
                                  <div className="col-12 col-md-6 col-lg-4 offset-lg-2 d-flex justify-content-start justify-content-md-center mb-2 mb-md-0">
                                    <form>
                                      <label className={this.state.radio3p ? "containerrdhut" : "containerrdhub"}>{(tr.t("Agree"))}
                                        <input checked={this.state.radio3p} type="radio" name="radio" onChange={this.radio3p} />
                                        <span className="checkmarku"></span>
                                      </label>
                                      <div className="spaceRadio" />
                                    </form>
                                  </div>
                                  <div className="col-12 col-md-6 col-lg-4 d-flex justify-content-start justify-content-md-center">
                                    <form>
                                      <label className={this.state.radio4p ? "containerrdhut" : "containerrdhub"}>{(tr.t("Nagree"))}
                                        <input checked={this.state.radio4p} type="radio" name="radio" onChange={this.radio4p} />
                                        <span className="checkmarku"></span>
                                      </label>
                                    </form>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col d-flex justify-content-center">
                                    <button
                                      hidden=
                                      {
                                        this.state.radio1p == this.state.radio1pbackup &&
                                        this.state.radio2p == this.state.radio2pbackup &&
                                        this.state.radio3p == this.state.radio3pbackup &&
                                        this.state.radio4p == this.state.radio4pbackup
                                      }
                                      className="sn_btn btnFit mx-auto"
                                      onClick={() => this.updateContracts()}>{tr.t("Save")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> : null
                  }
                  {/* ASSISTENZA  */}
                  {
                    this.state.screenNum == 5 ?
                      <div className="sn_body mx-auto">
                        <div className="container-md">
                          {/* profile */}
                          <div className="row">
                            <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                              <div className="sn_user d-flex align-items-center">
                                <div className="sn_user_profile">
                                  <button className="profileBtn" onClick={this.change0}></button>
                                  <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                </div>
                                <div className="sn_user_fullname sn_heading">
                                  {this.state.user.name} {this.state.user.surname}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* profile */}
                          <div className="row mt-3">
                            <div className="col-auto">
                              <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={false} />
                              {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                              {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                              <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={false} />
                              <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={false} />
                              <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={false} />
                              <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={true} />
                              <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                              {/*
													<div className="logOut">
														<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
													</div>
												*/}
                            </div>
                            <div className="col d-flex flex-column align-items-center justify-content-start">
                              <div className="sn_ua__container w-100 p-4 p-sm-5">
                                <div className="profilePnl">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="row">
                                        <div className="col-12 d-flex justify-content-center">
                                          <p className="mb-5 text-center">{tr.t("Contact")}</p>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-auto mx-auto">
                                          <div className="row mb-3">
                                            <div className="col-12 col-sm-auto mb-2 mb-sm-0">
                                              <div className="icon-box">
                                                <img src={assistel} className="img-fluid" alt="" />
                                              </div>
                                            </div>
                                            <div className="col-12 col-sm-auto d-flex align-items-center">
                                              <span>{tr.t("Telnumber")}</span>
                                            </div>
                                          </div>
                                          <div className="row mb-3">
                                            <div className="col-12 col-sm-auto mb-2 mb-sm-0">
                                              <div className="icon-box">
                                                <img src={assismail} className="img-fluid" />
                                              </div>
                                            </div>
                                            <div className="col-12 col-sm-auto d-flex align-items-center">
                                              <span><a className="sn_underline" href={"mailto:assistenza@mypass.cc"}>{tr.t("Assisemail")}</a></span>
                                            </div>
                                          </div>
                                          <div className="row mb-3">
                                            <div className="col-12 col-sm-auto mb-2 mb-sm-0">
                                              <div className="icon-box">
                                                <img src={assisfaq} className="img-fluid" alt="" />
                                              </div>
                                            </div>
                                            <div className="col-12 col-sm-auto d-flex align-items-center">
                                              <span>{tr.t("Read")}&#160;<a className="sn_underline" href={"https://mypass.ski/centro-assistenza/"} target="_blank">FAQ</a></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* FAQ is not ready yet, @valentina decided to hide it for now */}

                                      <div className="row mt-5">
                                        <div className="col-12 d-flex justify-content-end">
                                          <span className="text-right">V.{Config.version}</span>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> : null
                  }

                  {/* USER INFO  */}

                  {this.state.screenNum == 0 ?
                    <div className="sn_body mx-auto">
                      <div className="container-md">
                        {/* profile */}
                        <div className="row">
                          <div className="col-12 flex-column flex-sm-row mx-auto d-flex justify-content-between align-items-start align-items-sm-end">
                            <div className="sn_user d-flex align-items-center">
                              <div className="sn_user_profile">
                                <button className="profileBtn" onClick={this.change0}></button>
                                <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                              </div>
                              <div className="sn_user_fullname sn_heading">
                                {this.state.user.name} {this.state.user.surname}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* profile */}

                        <div className="row mt-3">
                          <div className="col-auto">
                            <SideBtn disable={this.state.screenNum == 1 ? true : false} text={tr.t("Tab1")} imageUnselected={tab1u} imageSelected={tab1s} onClick={this.change1} select={false} />
                            {/*<ReserveButton onClick={()=>this.goToReservation()} />*/}
                            {/*<ReserveButton icon="wallet" onClick={()=>this.goToReservation("wallet")} />*/}
                            <SideBtn disable={this.state.screenNum == 2 ? true : false} text={tr.t("Tab2")} imageUnselected={tab2u} imageSelected={tab2s} onClick={this.change2} select={false} />
                            <SideBtn alertside={this.state.ccRedAlert} disable={this.state.screenNum == 3 ? true : false} text={tr.t("Tab3")} imageUnselected={tab3u} imageSelected={tab3s} onClick={this.change3} select={false} />
                            <SideBtn disable={this.state.screenNum == 4 ? true : false} text={tr.t("Tab4")} imageUnselected={tab4u} imageSelected={tab4s} onClick={this.change4} select={false} />
                            <SideBtn disable={this.state.screenNum == 5 ? true : false} text={tr.t("Tab5")} imageUnselected={tab5u} imageSelected={tab5s} onClick={this.change5} select={false} />
                            <SideBtn text={tr.t("Logout")} imageUnselected={logout} imageSelected={logout} onClick={this.logout} select={false} />
                            {/*
													<div className="logOut">
														<button onClick={this.logout} className="logoutBtn">{tr.t("Logout")}</button>
													</div>
												*/}
                          </div>

                          <div className="col d-flex flex-column align-items-center justify-content-start">
                            {
                              this.state.profileView == 1 ?
                                <div className="sn_ua__container w-100 p-4 p-sm-5">
                                  <div className="profilePnl">
                                    <div className="row mb-3">
                                      <div className="col">
                                        <h3>{tr.t("Profile")}</h3>
                                      </div>
                                      <div className="col-auto">
                                        <div className="profileImg">
                                          <ReactFileReader base64={true} handleFiles={this.uploadProfilePic}>
                                            <a><div className="profileOverlay" /></a>
                                          </ReactFileReader>
                                          <Avatar src={this.getUserProfilePic()} className="responsiveProfile" size={'100%'} round="50%" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-12 col-md-6 mb-35 mb-sm-50">
                                        <input type="text" name="name" className="sn_input" value={this.state.user.name + ' ' + this.user.surname} />
                                      </div>
                                      <div className="col-12 col-md-6 mb-35 mb-sm-50">
                                        <input type="text" name="birthday" className="sn_input" value={this.state.user.data_nasc.split('-')[2] + '/' + this.state.user.data_nasc.split('-')[1] + '/' + this.state.user.data_nasc.split('-')[0]} />
                                      </div>
                                      <div className="col-12 mb-35 mb-sm-50">
                                        <div className="postion-relative">
                                          <input type="text" name="email" className="sn_input _has_btn" value={this.state.user.email} />
                                          <button className="forwardBtn" onClick={this.handleForwarde}></button>
                                        </div>
                                      </div>
                                      <div className="col-12 mb-35 mb-sm-50">
                                        <div className="postion-relative">
                                          <input type="password" name="password" className="sn_input _has_btn" value={this.state.Passwordform} />
                                          <button className="forwardBtn" onClick={this.handleForwardp}></button>
                                        </div>
                                      </div>
                                      <div className="col-12 mb-35 mb-sm-50">
                                        <input type="text" name="phone" placeholder={tr.t("Cellphone")} className="sn_input" maxLength="20" value={this.state.Phonenumberform} /*defaultValue={this.state.Phonenumberform || ''}*/ onBlur={(e) => this.changeTopn(e)} onChange={(e) => this.updateValuepn(e)} />
                                      </div>
                                      <div className="col d-flex flex-column flex-md-row justify-content-end">
                                        <button disabled={this.state.Phonenumberform.length < 10} className="sn_btn mb-3 mb-md-0 mr-md-3" onClick={this.updateUser}>{tr.t("Save")}</button>
                                        <button className="sn_btn redBtn" onClick={() => { this.setState({ deleteAccountAlert: true }) }}>{tr.t("Deletea")}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div> : null
                            }
                            {/*
														CHANGE EMAIL
												*/}
                            {this.state.profileView == 2 ?
                              <div className="sn_ua__container p-4 p-sm-5 w-100">
                                <div className="profilePnl">
                                  <div className="row mb-5">
                                    <div className="col-12">
                                      <h3 className="mb-4">{tr.t("Newmail")}</h3>
                                      <p>{tr.t("Yourmail")} <b>{this.state.user.email}</b></p>
                                      <p>{tr.t("Insertmail")}</p>
                                      <input type="email" name="mail" spellCheck="false" placeholder="email@mail.com" className={(this.state.emailErr) ? "sn_input err_red" : "sn_input err_no"} maxLength="50" value={this.state.Emailformnew} /*defaultValue={this.state.user.email || ''} */ onBlur={(e) => this.changeTone(e)} onChange={(e) => this.updateValuene(e)} />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col d-flex flex-column flex-md-row justify-content-end">
                                      <button className="sn_btn mb-3 mb-md-0 mr-md-3" onClick={this.handleContinue}>{tr.t("Continue")}</button>
                                      <button className="sn_btn" onClick={this.handleCancel}>{tr.t("Cancel")}</button>
                                    </div>
                                  </div>
                                </div>
                              </div> : null
                            }
                            {/*
														CHANGE PASSWORD
												*/}
                            {
                              this.state.profileView == 3 ?
                                <div className="sn_ua__container w-100 p-4 p-sm-5">
                                  <div className="profilePnl">
                                    <h3 className="mb-5">{tr.t("Changep")}</h3>
                                    <input type="password" name="oldpass" value={this.state.oldPassword} onChange={this.handleChangeOldPassword} placeholder={tr.t("Enterop")} className="sn_input  mb-35 mb-sm-50" maxLength="50" minLength="8" />
                                    <div className="position-relative">
                                      <input type={(this.state.passFlagu) ? "password" : "text"} spellCheck="false" name="newpassconfirm" value={this.state.newPassword} onChange={this.handleChangeNewPassword} placeholder={tr.t("Enternp")} className={(this.state.passErru) ? "err_red sn_input  mb-35 mb-sm-50" : "err_no sn_input  mb-35 mb-sm-50"} maxLength="50" minLength="8" />
                                      <div className="hideBtnPositionb">
                                        <HideBtn changei={(i) => { console.log("i", i); this.setState({ passFlagu: i }) }} />
                                      </div>
                                    </div>
                                    <input type={(this.state.passFlagu) ? "password" : "text"} spellCheck="false" name="newpass" value={this.state.newPasswordConfirm} onChange={this.handleChangeConfirmPassword} placeholder={tr.t("Enternp")} className={(this.state.passErru) ? "err_red sn_input mb-3" : "err_no sn_input mb-3"} maxLength="50" minLength="8" />
                                    <p className="mb-5">{tr.t("Passleast")}</p>
                                    <div className="col d-flex flex-column flex-md-row justify-content-end">
                                      <button disabled={this.state.newPassword.length < 8 || this.state.newPasswordConfirm.length < 8 || this.state.oldPassword.length == ''} className="sn_btn mb-3 mb-md-0 mr-md-3" onClick={this.handleConfirm}>{tr.t("Confirm")}</button>
                                      <button className="sn_btn" onClick={this.handleCancel}>{tr.t("Cancel")}</button>
                                    </div>
                                  </div>
                                </div> : null
                            }
                            {/* 
													CONFIRM EMAIL
											*/}
                            {
                              this.state.profileView == 4 ?
                                <div className="sn_ua__container p-4 p-sm-5 w-100">
                                  <div className="profilePnl">
                                    <h3 className="mb-5">{tr.t("Confirmail")}</h3>
                                    <p>{tr.t("Insertcode")}<br /> {tr.t("Yourmail") + " "} <b>{this.state.user.email}</b></p>
                                    {/* <input type="tel" name="code" placeholder="12345" className="txtStyleP" maxLength="5" /> */}
                                    <Cleave
                                      name="code"
                                      placeholder="12345"
                                      className="sn_input mb-3"
                                      maxLength={5}
                                      options={{ numericOnly: true, }}
                                      onChange={(event) => { this.setState({ emailCode: event.target.value }) }}
                                    />
                                    <div className="row mb-5">
                                      <div className="col-12 col-md-6 mb-3 mb-sm-0">
                                        <a onClick={this.handleResend}><h5>{tr.t("Resend")}</h5></a>
                                      </div>
                                      <div className="col-12 col-md-6 text-left text-md-right">
                                        <a onClick={this.changeEmail}><h5>{tr.t("Wrong")}</h5></a>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                      <button className="sn_btn" disabled={this.state.emailCode.length < 5} onClick={this.confirmEmailCode}>{tr.t("Next")}</button>
                                    </div>
                                  </div>
                                </div> : null
                            }
                            {/* 
													WRONG EMAIL
											*/}
                            {
                              this.state.profileView == 5 ?
                                <div className="sn_ua__container w-100 p-4 p-sm-5">
                                  <div className="profilePnl">
                                    <h3 className="mb-5">{tr.t("Changeeua")}</h3>
                                    <p>{tr.t("Insertynmailua")}</p>
                                    <input
                                      type="email"
                                      name="mail"
                                      spellCheck="false"
                                      placeholder="email@mail.com"
                                      onChange={this.handleNewEmail}
                                      className={(this.state.emailErr) ? "sn_input err_red mb-5" : "sn_input err_no mb-5"}
                                      maxLength="50"
                                    />
                                    <div className="col d-flex flex-column flex-md-row justify-content-end">
                                      <button disabled={!this.state.isEmailValid} onClick={this.modifyEmail} className="sn_btn mb-3 mb-md-0 mr-md-3">{tr.t("Save")}</button>
                                      <button className="sn_btn" onClick={this.handleCancelWrongEmail}>{tr.t("Cancel")}</button>
                                    </div>
                                  </div>
                                </div> : null
                            }
                          </div>
                        </div>
                      </div>
                    </div> : null
                  }
                </div>

                {/* ******************* MODALS ******************** */}

                {this.state.modal ?
                  <div className="containerModal">
                    {this.state.alertBlock ?
                      <AlertPnl textbar1={tr.t("Sureblock")} secondbar={true} textbar2={tr.t("Byblock")} singlebtn={true} textbtn1={tr.t("Blockcard")} sizebtn={"medium"} option1={"block"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertDocument ?
                      <AlertPnl textbar1={tr.t("Uploadocuments")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"upload"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertCard ?
                      <AlertPnl textbar1={tr.t("Attentionexpired")} singlebtn={true} textbtn1={tr.t("Updatecard")} option1={"update"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertWrongCCInsertion ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={`${tr.t("PaymentWentWrong")}${this.state.wrongCCInsertionError}`} doublebtnhor={true} textbtn1={tr.t("Retry")} textbtn2={tr.t("Cancel")} option1={"retryPayment"} option2={"cancel"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertPayment ?
                      <AlertPnl textbar1={tr.t("Attentionsuspended")} secondbar={true} textbar2={tr.t("Completepayment")} singlebtn={true} textbtn1={tr.t("Showsuspended")} option1={"complete"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertModification ?
                      <AlertPnl textbar1={tr.t("Datamodified")} secondbar={true} textbar2={tr.t("Datamodified_msg")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"modify"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertModificationAutoRenew ?
                      <AlertPnl closehide={true} textbar1={tr.t("Datamodified")} secondbar={true} textbar2={tr.t("Datamodified_msg")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"modifyAutoRenew"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertModificationProfilePhoto ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("ProfilePhotoChanged")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"modify_profilePhoto"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertElimination ?
                      <AlertPnl textbar1={tr.t("Suredelete")} secondbar={true} textbar2={tr.t("Alleliminate")} singlebtn={true} textbtn1={tr.t("Deletea")} sizebtn={"medium"} option1={"eliminate"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertResendemail ?
                      <AlertPnl textbar1={tr.t("Emailsent")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"resend"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertRenewservice ?
                      <AlertPnl textbar1={" "} secondbar={true} textbar2={tr.t("Charge")} doublebtnhor={true} textbtn1={tr.t("Renew")} textbtn2={tr.t("Cancel")} option1={"renew"} option2={"cancel"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.alertCardValidation ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.cardValidationErrorMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.userFeedbackForDeletion ?
                      <AlertPnl textbar1={tr.t("AccountDeleted")} secondbar={true} textbar2={tr.t("AccountDeleted_msg")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"deletedOk"} callback={this.alertResponse.bind(this)} /> : null
                    }
                    {this.state.cvvGuidAlert ?
                      <AlertPnl textbar1={tr.t("cvvDescription")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"cvvOK"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.alertWrong ?
                  <div className="containerModal">
                    {this.state.alertWrong ?
                      <AlertPnl textbar1={tr.t("Oops")} secondbar={true} textbar2={this.state.bankErrMsg} singlebtn={true} textbtn1={tr.t("Retry")} sizebtn={"medium"} option1={"retry"} callback={this.BankalertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.inScreenPopupShow ?
                  <div className="containerModal">
                    {this.state.inScreenPopupShow ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.doesCartExist ?
                  <div className="containerModal">
                    {this.state.doesCartExist ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("CartExsistMessage")} doublebtnhor={true} textbtn1={tr.t("Continue")} textbtn2={tr.t("Delete")} option1={"continuecart"} option2={"deletecart"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.deleteAccountAlert ?
                  <div className="containerModal">
                    {this.state.deleteAccountAlert ?
                      <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("Suredelete")} doublebtnhor={true} textbtn1={tr.t("Cancel")} textbtn2={tr.t("Delete")} option1={"deletaccancel"} option2={"deletaccok"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.deleteCC ?
                  <div className="containerModal">
                    {this.state.deleteCC ?
                      <AlertPnl textbar1={tr.t("removeCCTitle")} secondbar={true} textbar2={tr.t("removeCCNotice")} doublebtnhor={true} textbtn1={tr.t("Cancel")} textbtn2={tr.t("Delete")} option1={"delCCcancel"} option2={"delCCOK"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.OKPopupShow ?
                  <div className="containerModal">
                    {this.state.OKPopupShow ?
                      <AlertPnl textbar1={" "} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {this.state.changeEmailOK ?
                  <div className="containerModal">
                    {this.state.changeEmailOK ?
                      <AlertPnl textbar1={" "} secondbar={true} textbar2={tr.t("EmailChangedSuccessfully")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"changeEmailOK"} callback={this.alertResponse.bind(this)} /> : null
                    }
                  </div> : null
                }
                {(this.state.errorFlg || this.state.helpShow) ?
                  <div className="containerModal">
                    <AlertPnl textbar1={this.state.errmsg || this.state.helpMessage} secondbar={true} textbar2={' '} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"errorOK"} callback={this.alertResponse.bind(this)} />
                  </div> : null
                }
                {this.state.showThirdPartyAlert &&
                  <div className="containerModal">
                    <AlertPnl textbar1={this.state.thirdPartyAlertTitle} secondbar={true} textbar2={this.state.thirdPartyAlertMessage} doublebtnhor={true} textbtn1={this.state.thirdPartyAlertFirstButton} textbtn2={this.state.thirdPartyAlertScondButton} option1={this.state.thirdPartyAlertOption1} callback={(e) => this.onthirdPartCallback(e)} />
                  </div>
                }
              </BrowserView>
              <MobileView>
                <div className="sn_overlay d-lg-none"></div>
                <div className="container text-white">
                  <div className="row">
                    <div className="col-12 d-flex flex-column align-items-center p-5">
                      <img src={logo} className="mob-image-logo mb-5" />
                      <img src={application} className="mob-image mb-5" />
                      <p>{tr.t("Downloadapp")}</p>
                      <p className="mb-5">{tr.t("Downloadnow")}</p>
                      {
                        isIOS ?
                          <div className="mb-3">
                            <a className="goButton" href="https://itunes.apple.com/it/app/mypassci/id1444908864?mt=8" target="blanck"><img src={btnapplestore} /></a>
                          </div> : null
                        /* TODO: @Ali This button should redirect to Apple Store to download iOS version, tnx. */
                      }
                      {
                        isAndroid ?
                          <div className="mb-3">
                            <a className="goButton" href="https://play.google.com/store/apps/details?id=com.mypassci" target="blank"><img src={btngoogleplay} /></a>
                          </div> : null
                      }
                      <a onClick={this.onMobileTurnOnSito} >{tr.t("Returnsite")}</a>
                    </div>
                  </div>
                </div>
              </MobileView>
            </div>
          }
          <WaitLoad enable={this.state.isLoading || this.state.workFlowInProgress} />
          {this.state.gestpay && <GestPayHandler params={this.state.gestpayParams} callback={() => this.setState({ isLoading: false })} />}
        </div>
      </Router>
    );
  }
}

export default Userarea;


function isCreditCardExpired(date) {
  console.log(date);
  var d1 = new Date();
  var d2 = new Date(date);
  console.log("date ", d1.getFullYear(), d1.getMonth(), d2.getFullYear(), d2.getMonth());
  let expired = (d1.getFullYear() > d2.getFullYear()) || (d1.getFullYear() == d2.getFullYear()) && (d1.getMonth() > d2.getMonth())

  return expired;


}
function validateEmail(email) {
  var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return regexp.test(email);
}


class ReserveButton extends React.Component {
  render() {
    return (
      <button className="tabBtnu" style={{ flex: 1, display: 'none' }} onClick={this.props.onClick}>
        <div className="tabImg">
          <img src={this.props.icon === "wallet" ? ticketIcon : reserveToResortImg} style={{ width: '38%' }} />
        </div>
        {this.props.icon === "wallet" ? tr.t("goToWallet") : tr.t("reserveYourAccess")}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/Userarea/Userarea.js